type Recipe = {
  id: string;
  name: string;
  ingredients: string[];
  instructions: string[];
  instructionDetails?: string[];
  prepTime: string;
  cookTime: string;
  difficulty: 'Facile' | 'Moyen' | 'Difficile';
  imageUrl: string;
  category: string;
};

export const recipes: Recipe[] = [
  // ... existing recipes remain unchanged ...

  {
    id: 'chakhchoukha',
    name: 'Chakhchoukha',
    nameArabic: 'شخشوخة',
    ingredients: [
      'semoule',
      'agneau',
      'oignons',
      'tomates',
      'pois chiches',
      'ail',
      'paprika',
      'cumin',
      'piment rouge',
      "huile d'olive",
    ],
    instructions: [
      'Préparer la pâte et la découper en morceaux',
      'Cuire les morceaux de pâte à la vapeur',
      'Préparer la sauce avec la viande et les légumes',
      'Émietter la pâte cuite',
      'Assembler le plat avec la sauce',
    ],
    instructionDetails: [
      "Mélanger la semoule avec de l'eau et pétrir jusqu'à obtenir une pâte souple. Laisser reposer 30 minutes.",
      'Étaler la pâte et la découper en petits morceaux. Cuire à la vapeur pendant 20 minutes.',
      "Dans une marmite, faire revenir la viande avec les oignons et l'ail. Ajouter les épices et les tomates.",
      "Une fois la pâte cuite, l'émietter finement à la main.",
      'Disposer la pâte émiettée dans un grand plat et verser la sauce par-dessus.',
    ],
    prepTime: '45 min',
    cookTime: '1h30',
    difficulty: 'Difficile',
    imageUrl:
      'https://kaswila.com/wp-content/uploads/2024/12/chakhchoukha.webp',
    category: 'Plat Principal, Traditionnelles' ,
  },

  {
    id: 'chorbafrik',
    name: 'Chorba Frik',
    nameArabic: 'شوربة فريك',
    ingredients: [
      "250 g de viande d'agneau ou de poulet",
      '2 tomates râpées',
      'oignons',
      '1 cuillère à soupe de concentré de tomate',
      '1 poignée de pois chiches trempés la veille',
      '1/2 tasse de frik (blé concassé)',
      '1 bouquet de coriandre',
      '1/2 cuillère à café de cannelle',
      "1 cuillère à soupe d'huile",
      "1,5 L d'eau.",
      'Sel et poivre au goût',
    ],
    instructions: [
      "Faites revenir la viande avec l'oignon haché dans l'huile. Ajoutez les tomates râpées et le concentré de tomate.",
      'Ajoutez les pois chiches, la cannelle, le sel et le poivre. Mélangez bien.',
      "Versez l'eau et laissez mijoter jusqu'à ce que la viande soit presque cuite.",
      'Incorporez le frik et laissez cuire à feu doux en remuant régulièrement.',
      'Ajoutez la coriandre ciselée en fin de cuisson. Servez chaud.',
    ],
    instructionDetails: [
      "Mélanger la semoule avec de l'eau et pétrir jusqu'à obtenir une pâte souple. Laisser reposer 30 minutes.",
      'Étaler la pâte et la découper en petits morceaux. Cuire à la vapeur pendant 20 minutes.',
      "Dans une marmite, faire revenir la viande avec les oignons et l'ail. Ajouter les épices et les tomates.",
      "Une fois la pâte cuite, l'émietter finement à la main.",
      'Disposer la pâte émiettée dans un grand plat et verser la sauce par-dessus.',
    ],
    prepTime: '45 min',
    cookTime: '1h30',
    difficulty: 'Difficile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/chorba.webp',
    category: 'Plat Principal',
  },

  {
    id: 'mhadjeb',
    name: 'Mhadjeb',
    nameArabic: 'محاجب',
    ingredients: [
      'semoule fine',
      'farine',
      'huile',
      'sel',
      'oignons',
      'tomates',
      'poivrons',
      'épices',
    ],
    instructions: [
      'Préparer la pâte avec la semoule et la farine',
      'Préparer la farce aux légumes',
      'Étaler la pâte en cercles fins',
      'Garnir et plier les mhadjeb',
      'Cuire sur une plaque chaude',
    ],
    instructionDetails: [
      "Mélanger la semoule, la farine et le sel. Ajouter de l'eau progressivement pour obtenir une pâte souple.",
      "Faire revenir les légumes hachés avec les épices jusqu'à ce que la farce soit bien cuite.",
      'Diviser la pâte en boules et les étaler très finement.',
      'Déposer la farce au centre et plier pour former un carré.',
      "Cuire sur une plaque chaude avec un peu d'huile jusqu'à ce que ce soit doré des deux côtés.",
    ],
    prepTime: '30 min',
    cookTime: '20 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/Mhajeb.webp',
    category: 'Entrée',
  },

  {
    id: 'slatafelfel',
    name: 'Slata Felfel (Salade de poivrons simples)',
    nameArabic: 'سلطة فلفل',
    ingredients: [
      '3 poivrons verts',
      '1 tomate',
      '1 gousse d\'ail',
      '2 cuillères à soupe d\'huile d\'olive',
      'Sel',
    ],
    instructions: [
      'Coupez les poivrons et la tomate en petits morceaux.',
      'Écrasez l\'ail et mélangez-le avec les légumes.',
      'Ajoutez l\'huile d\'olive et le sel.',
      'Servez frais avec du pain.',
    ],
    prepTime: '10 min',
    cookTime: '0 min',
    difficulty: 'Facile',
    imageUrl:
      'https://kaswila.com/wp-content/uploads/2024/12/salade_felfel.webp',
    category: 'Entrée',
  },
  {
    id: 'tamina',
    name: 'Tamina',
    nameArabic: 'تمينة',
    ingredients: ['semoule grillée', 'beurre', 'miel', 'cannelle', 'amandes'],
    instructions: [
      'Griller la semoule',
      'Incorporer le beurre fondu',
      'Ajouter le miel et la cannelle',
      "Mélanger jusqu'à obtenir une pâte",
      'Décorer avec les amandes',
    ],
    instructionDetails: [
      "Faire griller la semoule dans une poêle jusqu'à ce qu'elle soit dorée et dégage un parfum de noisette.",
      'Ajouter le beurre fondu à la semoule encore chaude et bien mélanger.',
      "Incorporer le miel et la cannelle, mélanger jusqu'à obtenir une pâte homogène.",
      "Travailler la pâte jusqu'à ce qu'elle devienne malléable.",
      'Former des boules ou des losanges et décorer avec des amandes.',
    ],
    prepTime: '15 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/tamina.webp',
    category: 'Dessert',
  },
  {
    id: 'berkoukes',
    name: 'Berkoukes',
    nameArabic: 'بركوكس',
    ingredients: [
      'berkoukes',
      'agneau',
      'pois chiches',
      'carottes',
      'navets',
      'courgettes',
      'tomates',
      'oignons',
      'ail',
      'épices',
    ],
    instructions: [
      'Préparer le bouillon avec la viande',
      'Ajouter les légumes',
      'Cuire les pois chiches',
      'Ajouter le berkoukes',
      "Laisser mijoter jusqu'à cuisson complète",
    ],
    instructionDetails: [
      "Dans une marmite, faire revenir la viande avec les oignons et l'ail. Ajouter les épices.",
      "Incorporer les légumes coupés en morceaux et couvrir d'eau.",
      'Ajouter les pois chiches préalablement trempés.',
      'Quand les légumes sont presque cuits, ajouter le berkoukes.',
      "Laisser mijoter à feu doux jusqu'à ce que le berkoukes soit tendre et ait absorbé le bouillon.",
    ],
    prepTime: '30 min',
    cookTime: '1h45',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/berkoukes.webp',
    category: 'Plat Principal',
  },

  {
    id: 'rechta',
    name: 'Rechta',
    nameArabic: 'رشتة',
    ingredients: [
      'rechta (nouilles algériennes)',
      'agneau ou poulet',
      'pois chiches',
      'navets',
      'oignons',
      'beurre',
      'épices (cannelle, poivre)',
      'bouillon de volaille',
    ],
    instructions: [
      'Préparer la sauce avec la viande',
      'Ajouter les légumes et les pois chiches',
      'Cuire les rechta à la vapeur',
      'Mélanger la rechta avec un peu de beurre',
      'Servir avec la sauce et les légumes',
    ],
    instructionDetails: [
      'Dans une marmite, faire revenir la viande avec les oignons et les épices.',
      "Ajouter les pois chiches et les navets coupés en morceaux. Couvrir d'eau et laisser mijoter.",
      "Cuire les rechta à la vapeur en plusieurs étapes pour qu'elles soient tendres.",
      'Mélanger les nouilles avec un peu de beurre fondu.',
      'Servir les nouilles dans un plat avec la sauce, la viande et les légumes par-dessus.',
    ],
    prepTime: '40 min',
    cookTime: '1h30',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/rechta.webp',
    category: 'Plat Principal',
  },

  {
    id: 'couscous',
    name: 'Couscous',
    nameArabic: 'كسكس',
    ingredients: [
      'semoule de couscous',
      'agneau ou poulet',
      'pois chiches',
      'carottes',
      'navets',
      'courgettes',
      'tomates',
      'oignons',
      "huile d'olive",
      'épices (ras el hanout, cannelle)',
    ],
    instructions: [
      'Préparer la sauce avec la viande et les légumes',
      'Cuire la semoule de couscous à la vapeur',
      'Ajouter les pois chiches à la sauce',
      'Servir la semoule avec la sauce et la viande',
    ],
    instructionDetails: [
      'Faire revenir la viande avec les oignons et les épices dans une grande marmite.',
      "Ajouter les légumes coupés et les pois chiches trempés. Couvrir d'eau et laisser mijoter.",
      "Cuire la semoule de couscous à la vapeur en plusieurs étapes, en l'humidifiant légèrement entre chaque cuisson.",
      'Une fois les légumes et la viande cuits, disposer le couscous dans un grand plat.',
      'Servir avec la sauce chaude, les légumes et les morceaux de viande sur le dessus.',
    ],
    prepTime: '45 min',
    cookTime: '2h',
    difficulty: 'Difficile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/couscous.webp',
    category: 'Plat Principal',
  },
  {
    id: 'harira',
    name: 'Harira',
    nameArabic: 'حريرة',
    ingredients: [
      'viande hachée',
      'pois chiches',
      'lentilles',
      'tomates',
      'oignons',
      'céleri',
      'coriandre',
      'épices (curcuma, paprika, cannelle, gingembre)',
      'farine',
      "huile d'olive",
    ],
    instructions: [
      'Faire revenir les oignons avec la viande et les épices',
      'Ajouter les pois chiches et les lentilles',
      'Ajouter les tomates et le bouillon',
      "Laisser mijoter jusqu'à cuisson des lentilles",
      "Épaissir avec un mélange de farine et d'eau",
    ],
    instructionDetails: [
      "Faire chauffer l'huile d'olive dans une marmite et faire revenir les oignons avec la viande hachée et les épices.",
      'Ajouter les pois chiches trempés, les lentilles, les tomates râpées et le céleri.',
      "Couvrir d'eau ou de bouillon et laisser mijoter à feu moyen.",
      "Quand les lentilles sont cuites, mélanger la farine avec de l'eau pour former une pâte liquide et l'incorporer à la soupe.",
      "Laisser mijoter jusqu'à épaississement. Servir chaud avec du pain ou des dattes.",
    ],
    prepTime: '30 min',
    cookTime: '1h30',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/hrira.webp',
    category: 'repas',
  },
  {
    id: 'carbonara',
    name: 'Pâtes à la Carbonara',
    nameArabic: 'معكرونة كاربونارا',
    ingredients: [
      'spaghetti',
      'pancetta',
      'œufs',
      'parmesan râpé',
      'pecorino râpé',
      'ail',
      "huile d'olive",
      'sel',
      'poivre',
    ],
    instructions: [
      "Cuire les spaghetti dans une grande casserole d'eau bouillante salée.",
      "Faire revenir la pancetta avec l'ail dans une poêle.",
      'Battre les œufs avec le parmesan et le pecorino, assaisonner avec du sel et du poivre.',
      'Égoutter les pâtes, ajouter dans la poêle avec la pancetta, puis incorporer le mélange œufs-fromage hors du feu.',
      "Ajouter un peu d'eau de cuisson si nécessaire pour ajuster la consistance.",
    ],
    instructionDetails: [
      "Porter une grande casserole d'eau salée à ébullition, y cuire les spaghetti jusqu'à ce qu'ils soient al dente.",
      "Dans une poêle, faire chauffer l'huile d'olive et dorer la pancetta coupée en dés avec l'ail haché.",
      'Dans un bol, mélanger les œufs, le parmesan et le pecorino râpés.',
      "Égoutter les pâtes et les ajouter dans la poêle. Retirer du feu, verser le mélange d'œufs et mélanger vigoureusement.",
      "Ajuster la consistance avec de l'eau de cuisson des pâtes si nécessaire.",
    ],
    prepTime: '15 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/carbonara.webp',
    category: 'Plat principal',
  },

  {
    id: 'pesto',
    name: 'Pâtes au Pesto',
    nameArabic: 'معكرونة بالبيستو',
    ingredients: [
      'spaghetti',
      'basilic frais',
      'pignons de pin',
      'parmesan râpé',
      'ail',
      "huile d'olive",
      'sel',
      'poivre',
    ],
    instructions: [
      "Cuire les spaghetti dans une casserole d'eau salée.",
      "Préparer le pesto en mixant le basilic, les pignons, l'ail, et le parmesan.",
      "Ajouter l'huile d'olive en filet pour obtenir une texture lisse.",
      'Mélanger le pesto avec les pâtes égouttées.',
      'Servir avec des pignons grillés et du parmesan.',
    ],
    instructionDetails: [
      'Faire griller légèrement les pignons de pin pour intensifier leur saveur.',
      "Dans un mixeur, combiner le basilic, l'ail, les pignons et le parmesan. Mixer jusqu'à une consistance épaisse.",
      "Ajouter l'huile d'olive en filet tout en mixant pour obtenir une texture crémeuse.",
      'Égoutter les pâtes cuites et les mélanger immédiatement avec le pesto.',
      "Servir dans des assiettes, garnir de pignons grillés et d'un peu de parmesan.",
    ],
    prepTime: '10 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/pesto.webp',
    category: 'Plat principal',
  },
  {
    id: 'bolognaise',
    name: 'Pâtes à la Bolognaise',
    nameArabic: 'معكرونة بولونيز',
    ingredients: [
      'spaghetti',
      'viande hachée',
      'oignon',
      'ail',
      'carotte',
      'céleri',
      'tomates concassées',
      'concentré de tomate',
      "huile d'olive",
      'herbes de Provence',
      'sel',
      'poivre',
    ],
    instructions: [
      "Faire revenir l'oignon, l'ail, la carotte et le céleri dans une poêle.",
      "Ajouter la viande hachée et cuire jusqu'à dorure.",
      'Incorporer les tomates et le concentré de tomate, assaisonner.',
      'Laisser mijoter à feu doux pendant 30 minutes.',
      'Servir la sauce avec les spaghetti cuits.',
    ],
    instructionDetails: [
      "Dans une poêle, chauffer l'huile d'olive et faire revenir les légumes hachés jusqu'à ce qu'ils soient tendres.",
      "Ajouter la viande hachée, cuire jusqu'à ce qu'elle soit bien dorée, puis ajouter les tomates concassées et le concentré.",
      'Assaisonner avec les herbes de Provence, le sel et le poivre. Laisser mijoter à feu doux.',
      "Cuire les spaghetti dans une grande casserole d'eau bouillante salée.",
      'Égoutter les pâtes et servir avec la sauce bolognaise chaude.',
    ],
    prepTime: '20 min',
    cookTime: '30 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/Bolognaise.webp',
    category: 'Plat principal',
  },

  {
    id: 'mousse_chocolat',
    name: 'Mousse au Chocolat',
    nameArabic: 'موس الشوكولاتة',
    ingredients: [
      '200g de chocolat noir',
      '3 œufs',
      '30g de sucre',
      '1 pincée de sel',
    ],
    instructions: [
      'Faire fondre le chocolat au bain-marie.',
      'Séparer les blancs des jaunes d\'œufs.',
      'Incorporer les jaunes au chocolat fondu.',
      'Monter les blancs en neige avec une pincée de sel.',
      'Incorporer délicatement les blancs au mélange chocolaté.',
      'Réfrigérer au moins 3 heures avant de servir.',
    ],
    instructionDetails: [
      'Casser le chocolat en morceaux et le faire fondre doucement au bain-marie.',
      'Une fois fondu, ajouter les jaunes d\'œufs un par un tout en mélangeant.',
      'Monter les blancs en neige ferme en ajoutant le sucre progressivement.',
      'Incorporer les blancs au mélange chocolaté à l\'aide d\'une spatule en soulevant délicatement.',
      'Répartir la mousse dans des verrines et réfrigérer.',
    ],
    prepTime: '15 min',
    cookTime: '0 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/mousse.webp',
    category: 'Dessert',
  },
  {
    id: 'tiramisu',
    name: 'Tiramisu',
    nameArabic: 'تيراميسو',
    ingredients: [
      '250g de mascarpone',
      '3 œufs',
      '100g de sucre',
      '1 tasse de café',
      '24 biscuits à la cuillère',
      'cacao en poudre',
    ],
    instructions: [
      'Séparer les blancs des jaunes d\'œufs.',
      'Fouetter les jaunes avec le sucre jusqu\'à ce que le mélange blanchisse.',
      'Ajouter le mascarpone et bien mélanger.',
      'Monter les blancs en neige et les incorporer délicatement au mélange.',
      'Tremper les biscuits dans le café et les disposer dans un plat.',
      'Alterner couches de crème et de biscuits.',
      'Saupoudrer de cacao et réfrigérer 4 heures.',
    ],
    instructionDetails: [
      'Fouetter les jaunes d\'œufs avec le sucre jusqu\'à obtenir une texture mousseuse.',
      'Incorporer le mascarpone pour obtenir une crème homogène.',
      'Monter les blancs en neige ferme et les mélanger délicatement.',
      'Dans un plat, alterner une couche de biscuits trempés dans le café et une couche de crème.',
      'Saupoudrer de cacao avant de servir.',
    ],
    prepTime: '20 min',
    cookTime: '0 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/tiramisu.webp',
    category: 'Dessert',
  },
  {
    id: 'fondant_chocolat',
    name: 'Fondant au Chocolat',
    nameArabic: 'فوندان الشوكولاتة',
    ingredients: [
      '200g de chocolat noir',
      '100g de beurre',
      '100g de sucre',
      '50g de farine',
      '3 œufs',
    ],
    instructions: [
      'Préchauffer le four à 180°C.',
      'Faire fondre le chocolat et le beurre ensemble.',
      'Fouetter les œufs avec le sucre.',
      'Incorporer le mélange chocolat-beurre, puis la farine.',
      'Verser dans un moule et cuire 10 minutes.',
      'Servir tiède.',
    ],
    instructionDetails: [
      'Faire fondre le chocolat avec le beurre au bain-marie ou au micro-ondes.',
      'Dans un bol, battre les œufs avec le sucre jusqu\'à ce que le mélange mousse.',
      'Ajouter le chocolat fondu, puis incorporer la farine tamisée.',
      'Verser dans un moule beurré et enfourner pendant 10 minutes pour un cœur fondant.',
    ],
    prepTime: '10 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/Fondant.webp',
    category: 'Dessert',
  },
  {
    id: 'panna_cotta',
    name: 'Panna Cotta',
    nameArabic: 'بانا كوتا',
    ingredients: [
      '500ml de crème liquide',
      '3 feuilles de gélatine',
      '80g de sucre',
      '1 gousse de vanille',
      'coulis de fruits rouges',
    ],
    instructions: [
      'Faire tremper la gélatine dans l\'eau froide.',
      'Faire chauffer la crème avec le sucre et la gousse de vanille fendue.',
      'Ajouter la gélatine essorée hors du feu.',
      'Verser dans des verrines et réfrigérer 4 heures.',
      'Servir avec le coulis de fruits rouges.',
    ],
    instructionDetails: [
      'Tremper les feuilles de gélatine dans un bol d\'eau froide pour les ramollir.',
      'Dans une casserole, chauffer la crème liquide avec le sucre et la gousse de vanille fendue et grattée.',
      'Retirer du feu et incorporer les feuilles de gélatine essorées.',
      'Verser la préparation dans des verrines et laisser prendre au réfrigérateur.',
      'Servir avec un coulis de fruits rouges pour ajouter de la fraîcheur.',
    ],
    prepTime: '10 min',
    cookTime: '5 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/panna-cotta.webp',
    category: 'Dessert',
  },
  {
    id: 'salade_fruits',
    name: 'Salade de Fruits',
    nameArabic: 'سلطة فواكه',
    ingredients: [
      '2 pommes',
      '2 bananes',
      '2 oranges',
      '1 grappe de raisin',
      '2 cuillères à soupe de miel',
      '1 citron',
    ],
    instructions: [
      'Éplucher et couper les fruits en morceaux.',
      'Presser le citron et mélanger le jus avec le miel.',
      'Ajouter la sauce aux fruits et bien mélanger.',
      'Réfrigérer 1 heure avant de servir.',
    ],
    instructionDetails: [
      'Laver et préparer les fruits : couper les pommes, bananes, oranges et raisin.',
      'Dans un bol, mélanger le jus de citron avec le miel.',
      'Verser la sauce sur les fruits et mélanger délicatement.',
      'Placer au réfrigérateur pour servir bien frais.',
    ],
    prepTime: '15 min',
    cookTime: '0 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2024/12/Fruits.webp',
    category: 'Dessert',
  },

  {
    id: 'tarte_amandes',
    name: 'Tarte aux Amandes',
    nameArabic: 'تارت اللوز',
    ingredients: [
      '1 pâte sablée',
      '100g de poudre d\'amandes',
      '100g de sucre',
      '100g de beurre fondu',
      '2 œufs',
      '1 cuillère à soupe de farine',
      'quelques amandes effilées',
    ],
    instructions: [
      'Préchauffer le four à 180°C.',
      'Étaler la pâte sablée dans un moule à tarte.',
      'Mélanger les œufs, le sucre, la poudre d\'amandes, la farine et le beurre fondu.',
      'Verser la préparation sur la pâte.',
      'Parsemer d\'amandes effilées.',
      'Enfourner pendant 25 à 30 minutes.',
      'Laisser tiédir avant de servir.',
    ],
    instructionDetails: [
      'Foncer un moule avec la pâte sablée, la piquer à la fourchette.',
      'Dans un saladier, fouetter les œufs avec le sucre jusqu\'à ce que le mélange blanchisse.',
      'Ajouter la poudre d\'amandes, la farine, puis le beurre fondu. Bien mélanger.',
      'Verser cette crème d\'amandes sur le fond de tarte.',
      'Parsemer d\'amandes effilées pour plus de croquant.',
      'Cuire environ 25 à 30 minutes jusqu\'à ce que la tarte soit dorée.',
      'Servir tiède ou froide, nature ou accompagnée d\'une boule de glace.',
    ],
    prepTime: '15 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl:
      'https://kaswila.com/wp-content/uploads/2025/05/Tarte-aux-Amandes.webp',
    category: 'Dessert',
  },

  {
    id: 'saint_honore',
    name: 'Saint-Honoré à la Crème Diplomate',
    nameArabic: 'سان أونوريه',
    ingredients: [
      'pâte feuilletée',
      'pâte à choux',
      'crème pâtissière',
      'crème fouettée',
      'gélatine',
      'sucre',
      'eau',
      'vanille',
      'chantilly pour décoration',
    ],
    instructions: [
      'Préparer la pâte feuilletée et cuire au four.',
      'Réaliser des choux et les cuire.',
      'Préparer la crème diplomate.',
      'Garnir les choux et les coller sur la base.',
      'Remplir le centre avec la crème et décorer à la poche à douille.',
    ],
    instructionDetails: [
      'Découper un cercle de pâte feuilletée et le cuire jusqu\'à dorure.',
      'Préparer une pâte à choux, pocher de petits choux, les cuire au four.',
      'Réaliser une crème diplomate : crème pâtissière + gélatine + crème fouettée.',
      'Garnir les choux de crème et les coller avec du caramel sur le bord du disque.',
      'Remplir le centre avec la crème, lisser, puis décorer avec de la chantilly.',
    ],
    prepTime: '1h',
    cookTime: '30 min',
    difficulty: 'Difficile',
    imageUrl:
      'https://kaswila.com/wp-content/uploads/2025/05/Saint-Honore.webp',
    category: 'Dessert',
  },

  {
    id: 'charlotte_royale_fraises',
    name: 'Charlotte Royale aux Fraises',
    nameArabic: 'شارلوت رويال بالفراولة',
    ingredients: [
      'génoise',
      'fraises fraîches',
      'crème chantilly',
      'gélatine',
      'sucre',
      'vanille',
    ],
    instructions: [
      'Préparer une génoise et la couper en tranches.',
      'Tapisser un saladier de tranches.',
      'Préparer la mousse aux fraises.',
      'Verser dans le moule tapissé.',
      'Réfrigérer minimum 4h.',
    ],
    instructionDetails: [
      'Cuire une génoise fine, la rouler avec de la confiture, couper en tranches.',
      'Chemiser un saladier avec les rondelles.',
      'Mixer les fraises avec du sucre, incorporer de la chantilly et de la gélatine fondue.',
      'Verser la mousse dans le saladier chemisé.',
      'Réfrigérer plusieurs heures, puis démouler.',
    ],
    prepTime: '30 min',
    cookTime: '10 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/05/Charlotte-.webp',
    category: 'Dessert',
  },
  {
    id: 'brioche_creme_framboise',
    name: 'Brioche à la Crème Pâtissière et Framboises',
    nameArabic: 'بريوش بالكريمة والتوت',
    ingredients: [
      'pâte à brioche',
      'crème pâtissière',
      'framboises fraîches',
      'œuf pour dorure',
      'sucre glace',
    ],
    instructions: [
      'Préparer une pâte à brioche et la laisser lever.',
      'Étaler et garnir de crème pâtissière.',
      'Ajouter les framboises.',
      'Rouler et couper des tronçons.',
      'Cuire au four et saupoudrer de sucre glace.',
    ],
    instructionDetails: [
      'Préparer une pâte briochée, la laisser lever 1h à température ambiante.',
      'Étaler la pâte, garnir de crème pâtissière froide.',
      'Disposer des framboises fraîches de façon homogène.',
      'Rouler la pâte comme un boudin et couper des parts.',
      'Disposer dans un moule, laisser lever 30 min puis cuire à 180°C 20–25 min.',
    ],
    prepTime: '1h',
    cookTime: '25 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/05/Brioche-.webp',
    category: 'Dessert',
  },

  {
    id: 'cake_marbre',
    name: 'Cake Marbré',
    nameArabic: 'كيك مرمر',
    ingredients: [
      '200g de farine',
      '150g de sucre',
      '125g de beurre',
      '3 œufs',
      '1 sachet de levure',
      '2 cuillères à soupe de cacao',
      '1 cuillère à soupe de lait',
      '1 pincée de sel',
    ],
    instructions: [
      'Préchauffer le four à 180°C.',
      'Battre le beurre et le sucre, ajouter les œufs un à un.',
      'Incorporer la farine, la levure et le sel.',
      'Diviser la pâte en deux, ajouter le cacao dans une moitié.',
      'Verser les deux pâtes en alternant dans le moule.',
      'Cuire 40 à 45 minutes.',
    ],
    instructionDetails: [
      'Mélanger le beurre mou avec le sucre jusqu\'à consistance crémeuse.',
      'Ajouter les œufs un à un en mélangeant bien.',
      'Incorporer la farine tamisée avec la levure et le sel.',
      'Diviser la pâte en deux, ajouter le cacao et le lait dans l\'une.',
      'Verser en alternant les couches dans un moule beurré.',
      'Cuire 40–45 min à 180°C. Laisser tiédir avant de démouler.',
    ],
    prepTime: '15 min',
    cookTime: '45 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/05/cake.webp',
    category: 'Dessert',
  },
  {
    id: 'basboussa',
    name: 'Basboussa',
    nameArabic: 'بسبوسة',
    ingredients: [
      '200g de semoule moyenne',
      '100g de sucre',
      '100g de yaourt nature',
      '80g de beurre fondu',
      '1 sachet de levure chimique',
      'eau de fleur d\'oranger',
      'sirop sucre-eau',
    ],
    instructions: [
      'Mélanger tous les ingrédients sauf le sirop.',
      'Verser dans un moule huilé.',
      'Cuire 25–30 min à 180°C.',
      'Verser le sirop froid à la sortie du four.',
      'Laisser absorber avant de couper.',
    ],
    instructionDetails: [
      'Dans un bol, mélanger semoule, sucre, levure, yaourt et beurre.',
      'Verser dans un moule carré beurré.',
      'Cuire jusqu\'à dorure. Pendant ce temps, préparer un sirop eau + sucre + fleur d\'oranger.',
      'Verser le sirop froid sur le gâteau chaud.',
      'Laisser imbiber, puis couper en parts.',
    ],
    prepTime: '10 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/05/besboussa.webp',
    category: 'Dessert',
  },
  {
    id: 'basboussa_chocolat',
    name: 'Basboussa au Chocolat',
    nameArabic: 'بسبوسة بالشوكولاتة',
    ingredients: [
      '200g de semoule moyenne',
      '100g de sucre',
      '80g de beurre fondu',
      '1 yaourt nature',
      '2 cuillères à soupe de cacao',
      '1 sachet de levure',
      'sirop chocolat ou sirop simple',
    ],
    instructions: [
      'Mélanger les ingrédients secs.',
      'Ajouter le yaourt et le beurre fondu.',
      'Verser dans un moule beurré.',
      'Cuire à 180°C pendant 25–30 minutes.',
      'Verser le sirop au chocolat.',
    ],
    instructionDetails: [
      'Mélanger semoule, sucre, cacao et levure.',
      'Ajouter yaourt et beurre, bien homogénéiser.',
      'Cuire jusqu\'à ce que la surface soit bien ferme.',
      'Verser un sirop chaud ou froid au chocolat ou nature.',
      'Laisser reposer avant de servir.',
    ],
    prepTime: '10 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl:
      'https://kaswila.com/wp-content/uploads/2025/07/basboussa-au-chocolat.webp',
    category: 'Dessert',
  },
  {
    id: 'basboussa_noix_coco',
    name: 'Basboussa à la Noix de Coco',
    nameArabic: 'بسبوسة بجوز الهند',
    ingredients: [
      '150g de semoule moyenne',
      '50g de noix de coco râpée',
      '100g de sucre',
      '100g de yaourt',
      '80g de beurre fondu',
      '1 sachet de levure',
      'sirop sucre-eau',
    ],
    instructions: [
      'Mélanger tous les ingrédients sauf le sirop.',
      'Verser dans un moule huilé.',
      'Cuire à 180°C pendant 30 minutes.',
      'Verser le sirop froid sur le gâteau chaud.',
      'Décorer avec de la noix de coco.',
    ],
    instructionDetails: [
      'Dans un saladier, mélanger semoule, coco râpée, sucre, levure.',
      'Ajouter le yaourt et le beurre fondu, bien mélanger.',
      'Cuire jusqu\'à ce que la basboussa soit dorée.',
      'Verser le sirop sucré à la sortie du four.',
      'Décorer de coco ou d\'amandes.',
    ],
    prepTime: '10 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/basboussa-.webp',
    category: 'Dessert',
  },
  {
    id: 'kalb_el_louz',
    name: 'Kalb el Louz',
    nameArabic: 'قلب اللوز',
    ingredients: [
      '500g de semoule moyenne',
      '200g de sucre',
      '150g de beurre fondu',
      '1 cuillère à soupe d\'eau de fleur d\'oranger',
      'eau tiède',
      'amandes concassées',
      'sirop épais',
    ],
    instructions: [
      'Mélanger la semoule, le sucre et le beurre.',
      'Ajouter l\'eau de fleur d\'oranger et l\'eau.',
      'Laisser reposer la pâte 2h.',
      'Ajouter les amandes, verser dans un plat.',
      'Cuire 45 min à 180°C.',
      'Verser le sirop chaud.',
    ],
    instructionDetails: [
      'Mélanger semoule, sucre et beurre fondu jusqu\'à texture sableuse.',
      'Ajouter un peu d\'eau et l\'eau de fleur d\'oranger pour former une pâte épaisse.',
      'Laisser reposer 2 heures pour bien hydrater.',
      'Ajouter les amandes, lisser et découper en losanges.',
      'Cuire lentement pour que ce soit bien fondant, puis imbiber de sirop chaud.',
    ],
    prepTime: '15 min (+2h repos)',
    cookTime: '45 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/Kalb-el-Louz.webp',
    category: 'Dessert',
  },

  {
    id: 'griwech_chebakiya',
    name: 'Griwech - Chebakiya',
    nameArabic: 'قريوش - شباكية',
    ingredients: [
      '500g de farine',
      '1 œuf',
      '100g de beurre fondu',
      '1 pincée de sel',
      '1 c. à soupe de vinaigre',
      '1 c. à soupe d\'eau de fleur d\'oranger',
      'graines de sésame',
      'eau tiède',
      'huile pour friture',
      'miel',
    ],
    instructions: [
      'Mélanger les ingrédients secs puis ajouter les liquides.',
      'Pétrir la pâte et laisser reposer.',
      'Étaler, découper et former les griwechs.',
      'Frire jusqu\'à dorure.',
      'Plonger dans le miel chaud, parsemer de sésame.',
    ],
    instructionDetails: [
      'Mélanger farine, sel, graines de sésame puis incorporer beurre, œuf, vinaigre et eau de fleur d\'oranger.',
      'Ajouter un peu d\'eau tiède pour former une pâte lisse. Laisser reposer 30 min.',
      'Étaler la pâte, découper en bandes, tresser ou former les chebakiyas.',
      'Faire frire dans une huile chaude.',
      'Tremper dans du miel chaud aromatisé à la fleur d\'oranger.',
    ],
    prepTime: '30 min',
    cookTime: '20 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/griwech_chebakiya.webp',
    category: 'Dessert',
  },
  {
    id: 'khobz_tounes',
    name: 'Khobz Tounes',
    nameArabic: 'خبز تونس',
    ingredients: [
      '250g de poudre d\'amandes',
      '100g de chapelure fine',
      '200g de sucre',
      '6 œufs',
      'zeste de citron',
      'eau de fleur d\'oranger',
      'sirop de sucre',
    ],
    instructions: [
      'Mélanger les œufs et le sucre.',
      'Ajouter les amandes, chapelure, zeste et fleur d\'oranger.',
      'Verser dans un moule beurré.',
      'Cuire à 180°C 25 à 30 minutes.',
      'Arroser de sirop chaud à la sortie du four.',
    ],
    instructionDetails: [
      'Fouetter les œufs avec le sucre jusqu\'à blanchiment.',
      'Ajouter la poudre d\'amandes, la chapelure, le zeste de citron et un peu de fleur d\'oranger.',
      'Verser dans un moule rectangulaire.',
      'Cuire jusqu\'à belle dorure.',
      'Arroser généreusement de sirop dès la sortie du four.',
    ],
    prepTime: '10 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/khobz_tounes.webp',
    category: 'Dessert',
  },
  {
    id: 'tarte_citron_fraise',
    name: 'Tarte Citron-Fraise',
    nameArabic: 'تارت الليمون والفراولة',
    ingredients: [
      'pâte sablée',
      'crème au citron',
      'fraises fraîches',
      'sucre glace',
      'gélatine ou nappage',
    ],
    instructions: [
      'Cuire la pâte à blanc.',
      'Préparer la crème au citron.',
      'Verser la crème sur le fond refroidi.',
      'Disposer les fraises tranchées.',
      'Napper ou saupoudrer de sucre glace.',
    ],
    instructionDetails: [
      'Foncer un moule avec la pâte sablée, la cuire à blanc 15 min à 180°C.',
      'Réaliser une crème citron à base de jus de citron, œufs, sucre et beurre.',
      'Verser la crème refroidie sur la pâte.',
      'Ajouter des fraises coupées en deux.',
      'Napper d\'un peu de gélatine ou saupoudrer de sucre glace.',
    ],
    prepTime: '20 min',
    cookTime: '20 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/tarte-citron-fraise.webp',
    category: 'Dessert',
  },
  {
    id: 'brownies',
    name: 'Brownies',
    nameArabic: 'براونيز',
    ingredients: [
      '200g de chocolat noir',
      '150g de beurre',
      '150g de sucre',
      '3 œufs',
      '100g de farine',
      '1 pincée de sel',
      'noix ou noisettes (optionnel)',
    ],
    instructions: [
      'Faire fondre le chocolat avec le beurre.',
      'Fouetter les œufs avec le sucre.',
      'Ajouter le chocolat fondu puis la farine.',
      'Verser dans un moule carré.',
      'Cuire 20 à 25 minutes à 180°C.',
    ],
    instructionDetails: [
      'Faire fondre chocolat et beurre au bain-marie.',
      'Fouetter les œufs et le sucre jusqu\'à blanchir.',
      'Ajouter le mélange chocolaté, puis incorporer la farine et une pincée de sel.',
      'Verser dans un moule beurré, ajouter des noix si souhaité.',
      'Cuire 20–25 min à 180°C. Laisser refroidir avant de découper.',
    ],
    prepTime: '15 min',
    cookTime: '25 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/brownies.webp',
    category: 'Dessert',
  },
  {
    id: 'bradjs',
    name: 'Bradjs',
    nameArabic: 'برادج',
    ingredients: [
      '500g de semoule moyenne',
      '150g de pâte de dattes',
      'eau tiède',
      'huile',
      'sel',
      'cannelle',
      'eau de fleur d\'oranger',
    ],
    instructions: [
      'Préparer la pâte avec semoule, sel et eau.',
      'Préparer la pâte de dattes avec cannelle et fleur d\'oranger.',
      'Étaler deux abaisses de pâte, farcir entre deux couches.',
      'Découper en losanges.',
      'Cuire sur une plaque chaude.',
    ],
    instructionDetails: [
      'Mouiller la semoule avec un peu d\'huile et d\'eau tiède salée pour faire une pâte souple.',
      'Mélanger la pâte de dattes avec cannelle et fleur d\'oranger.',
      'Étaler une abaisse de pâte, étaler la farce, recouvrir d\'une seconde abaisse.',
      'Découper en losanges ou carrés.',
      'Cuire sur une plaque ou poêle chaude sans matière grasse.',
    ],
    prepTime: '30 min',
    cookTime: '15 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/bradjs.webp',
    category: 'Dessert',
  },

  {
    id: 'makrout',
    name: 'Makrout',
    nameArabic: 'مقروط',
    ingredients: [
      '500g de semoule moyenne',
      '150g de pâte de dattes',
      '100g de beurre fondu',
      'eau de fleur d\'oranger',
      'cannelle',
      'huile pour friture',
      'miel',
    ],
    instructions: [
      'Mélanger semoule et beurre fondu.',
      'Ajouter de l\'eau de fleur d\'oranger pour obtenir une pâte souple.',
      'Former des boudins farcis à la pâte de dattes.',
      'Découper en losanges et frire.',
      'Tremper dans le miel.',
    ],
    instructionDetails: [
      'Sabler la semoule avec le beurre fondu, puis ajouter l\'eau de fleur d\'oranger petit à petit.',
      'Étaler en forme de boudin, garnir de pâte de dattes parfumée à la cannelle.',
      'Refermer et rouler à nouveau, puis couper en losanges.',
      'Frire dans l\'huile chaude jusqu\'à dorure.',
      'Plonger dans du miel tiède quelques secondes.',
    ],
    prepTime: '30 min',
    cookTime: '15 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/makrout.webp',
    category: 'Dessert',
  },
  {
    id: 'cookies',
    name: 'Cookies',
    nameArabic: 'كوكيز',
    ingredients: [
      '200g de farine',
      '120g de beurre',
      '100g de sucre roux',
      '1 œuf',
      '1 sachet de levure',
      '100g de pépites de chocolat',
      '1 pincée de sel',
    ],
    instructions: [
      'Battre le beurre et le sucre.',
      'Ajouter l\'œuf, puis la farine, levure et sel.',
      'Incorporer les pépites.',
      'Former des boules sur une plaque.',
      'Cuire 10 à 12 minutes à 180°C.',
    ],
    instructionDetails: [
      'Travailler le beurre mou avec le sucre jusqu\'à obtention d\'un mélange crémeux.',
      'Ajouter l\'œuf, bien mélanger.',
      'Incorporer les ingrédients secs, puis les pépites.',
      'Déposer des petits tas sur une plaque recouverte de papier cuisson.',
      'Cuire jusqu\'à ce que les bords soient dorés.',
    ],
    prepTime: '10 min',
    cookTime: '12 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/cookies.webp',
    category: 'Dessert',
  },
  {
    id: 'zlabia',
    name: 'Zlabia',
    nameArabic: 'زلابية',
    ingredients: [
      '250g de farine',
      '1 c. à soupe de maïzena',
      '1 c. à café de levure sèche',
      '1 pincée de sel',
      'eau tiède',
      'huile pour friture',
      'sirop de sucre au safran ou miel',
    ],
    instructions: [
      'Préparer une pâte fluide et laisser fermenter.',
      'Remplir une poche à douille.',
      'Former des spirales dans l\'huile chaude.',
      'Frire jusqu\'à dorure.',
      'Tremper dans le sirop ou miel.',
    ],
    instructionDetails: [
      'Mélanger farine, maïzena, levure, sel, puis ajouter de l\'eau pour obtenir une pâte lisse.',
      'Laisser fermenter 1 à 2h.',
      'Verser dans une poche ou bouteille à embout fin.',
      'Faire frire en dessinant des spirales dans l\'huile chaude.',
      'Tremper dans un sirop parfumé (miel, fleur d\'oranger ou safran).',
    ],
    prepTime: '15 min (+repos)',
    cookTime: '10 min',
    difficulty: 'Difficile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/zlabia.webp',
    category: 'Dessert',
  },
  {
    id: 'baklawa',
    name: 'Baklawa',
    nameArabic: 'بقلاوة',
    ingredients: [
      'feuilles de pâte filo',
      '300g de fruits secs (amandes, pistaches, noix)',
      '150g de beurre fondu',
      '100g de sucre',
      '1 c. à soupe de cannelle',
      'sirop (sucre, eau, fleur d\'oranger)',
    ],
    instructions: [
      'Beurrer les feuilles de pâte filo.',
      'Superposer plusieurs couches dans un moule.',
      'Ajouter une couche de fruits secs sucrés.',
      'Couvrir de feuilles et découper en losanges.',
      'Cuire à 180°C puis verser le sirop.',
    ],
    instructionDetails: [
      'Mixer les fruits secs avec le sucre et la cannelle.',
      'Beurrer chaque feuille et tapisser un moule de plusieurs couches.',
      'Ajouter la farce, recouvrir de feuilles beurrées.',
      'Découper en losanges avant cuisson.',
      'Cuire jusqu\'à dorure, puis arroser de sirop tiède.',
    ],
    prepTime: '30 min',
    cookTime: '35 min',
    difficulty: 'Difficile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/eklawa.webp',
    category: 'Dessert',
  },
  {
    id: 'biscuits_citron',
    name: 'Biscuits Fondants au Citron',
    nameArabic: 'بسكويت الليمون',
    ingredients: [
      '200g de farine',
      '100g de beurre',
      '80g de sucre glace',
      '1 œuf',
      'zeste de citron',
      'jus de citron',
      '1 sachet de levure',
      'sucre glace pour décoration',
    ],
    instructions: [
      'Mélanger beurre et sucre glace.',
      'Ajouter l\'œuf, zeste et jus de citron.',
      'Incorporer farine et levure.',
      'Former des boules, rouler dans le sucre glace.',
      'Cuire à 180°C 10 à 12 min.',
    ],
    instructionDetails: [
      'Crémer le beurre avec le sucre glace.',
      'Ajouter l\'œuf, le zeste et un peu de jus de citron.',
      'Incorporer les ingrédients secs pour former une pâte molle.',
      'Former des boules, les enrober de sucre glace.',
      'Cuire jusqu\'à craquelures visibles.',
    ],
    prepTime: '15 min',
    cookTime: '12 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/07/biscuits-citron.webp',
    category: 'Dessert',
  },

  {
    id: 'mac_cheese',
    name: 'Mac & Cheese',
    nameArabic: 'ماك آند تشيز',
    ingredients: [
      '400g de macaronis',
      '300g de cheddar râpé',
      '100g de gruyère râpé',
      '500ml de lait',
      '50g de beurre',
      '50g de farine',
      '1 pincée de noix de muscade',
      'sel et poivre',
      'chapelure pour gratiner',
    ],
    instructions: [
      'Cuire les macaronis selon les instructions du paquet.',
      'Préparer une béchamel avec le beurre, la farine et le lait.',
      'Ajouter les fromages râpés à la béchamel.',
      'Mélanger les pâtes avec la sauce au fromage.',
      'Verser dans un plat à gratin, parsemer de chapelure et gratiner.',
    ],
    instructionDetails: [
      'Faire cuire les macaronis dans une grande casserole d\'eau bouillante salée jusqu\'à ce qu\'ils soient al dente.',
      'Dans une casserole, faire fondre le beurre, ajouter la farine et cuire 2 minutes. Verser le lait progressivement en fouettant.',
      'Hors du feu, incorporer les fromages râpés, assaisonner avec sel, poivre et muscade.',
      'Égoutter les pâtes et les mélanger avec la sauce au fromage.',
      'Préchauffer le four à 200°C. Verser dans un plat beurré, parsemer de chapelure et gratiner 15-20 minutes.',
    ],
    prepTime: '15 min',
    cookTime: '25 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Mac-Cheese.webp',
    category: 'Plat principal',
  },

  {
    id: 'salade_cesar',
    name: 'Salade César',
    nameArabic: 'سلطة قيصر',
    ingredients: [
      '2 cœurs de laitue romaine',
      '200g de blanc de poulet',
      '100g de parmesan',
      '4 tranches de pain de mie',
      '2 gousses d\'ail',
      '3 cuillères à soupe de mayonnaise',
      '1 cuillère à soupe de moutarde',
      'jus de citron',
      'huile d\'olive',
      'sel et poivre',
    ],
    instructions: [
      'Cuire le blanc de poulet et le découper en lamelles.',
      'Préparer les croûtons avec le pain et l\'ail.',
      'Laver et couper la salade romaine.',
      'Préparer la sauce césar avec mayonnaise, moutarde et citron.',
      'Assembler la salade avec tous les ingrédients.',
    ],
    instructionDetails: [
      'Faire cuire le blanc de poulet dans une poêle avec un peu d\'huile, assaisonner et découper en lamelles.',
      'Couper le pain en cubes, les faire dorer dans une poêle avec de l\'ail haché et de l\'huile d\'olive.',
      'Laver soigneusement la laitue romaine et la couper en morceaux.',
      'Mélanger mayonnaise, moutarde, jus de citron, sel et poivre pour la sauce.',
      'Dans un grand saladier, mélanger la salade, le poulet, les croûtons, la sauce et le parmesan râpé.',
    ],
    prepTime: '20 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://images.unsplash.com/photo-1546793665-c74683f339c1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    category: 'Entrée',
  },

  {
    id: 'risotto_legumes',
    name: 'Risotto aux légumes',
    nameArabic: 'ريزوتو بالخضار',
    ingredients: [
      '300g de riz arborio',
      '1 courgette',
      '1 poivron rouge',
      '200g de petits pois',
      '1 oignon',
      '2 gousses d\'ail',
      '1L de bouillon de légumes',
      '100g de parmesan râpé',
      '50g de beurre',
      'huile d\'olive',
      'sel et poivre',
    ],
    instructions: [
      'Faire revenir l\'oignon et l\'ail dans l\'huile d\'olive.',
      'Ajouter le riz et le faire nacrer 2 minutes.',
      'Ajouter le bouillon louche par louche en remuant.',
      'Incorporer les légumes et terminer avec beurre et parmesan.',
    ],
    instructionDetails: [
      'Couper les légumes en petits dés. Faire chauffer le bouillon dans une casserole.',
      'Dans une grande poêle, faire revenir l\'oignon haché et l\'ail dans l\'huile d\'olive.',
      'Ajouter le riz arborio et le faire nacrer en remuant pendant 2 minutes.',
      'Ajouter le bouillon chaud louche par louche en remuant constamment.',
      'À mi-cuisson, ajouter les légumes. En fin de cuisson, incorporer le beurre et le parmesan. Servir immédiatement.',
    ],
    prepTime: '15 min',
    cookTime: '25 min',
    difficulty: 'Moyen',
    imageUrl: 'https://images.unsplash.com/photo-1476124369491-e7addf5db371?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    category: 'Plat principal',
  },

  {
    id: 'omelette_espagnole',
    name: 'Omelette espagnole',
    nameArabic: 'أومليت إسبانية',
    ingredients: [
      '6 œufs',
      '4 pommes de terre moyennes',
      '1 gros oignon',
      'huile d\'olive',
      'sel',
    ],
    instructions: [
      'Éplucher et couper les pommes de terre en rondelles.',
      'Faire cuire les pommes de terre dans l\'huile d\'olive.',
      'Ajouter l\'oignon émincé et cuire ensemble.',
      'Battre les œufs et mélanger avec les pommes de terre.',
      'Cuire l\'omelette des deux côtés dans la poêle.',
    ],
    instructionDetails: [
      'Éplucher les pommes de terre et les couper en rondelles de 3mm d\'épaisseur.',
      'Dans une poêle, chauffer l\'huile d\'olive et faire cuire les pommes de terre à feu moyen pendant 15 minutes.',
      'Ajouter l\'oignon émincé et cuire 5 minutes de plus. Égoutter l\'excès d\'huile.',
      'Battre les œufs avec du sel, ajouter les pommes de terre et l\'oignon, mélanger délicatement.',
      'Dans la même poêle avec un peu d\'huile, verser le mélange et cuire 5 minutes de chaque côté.',
    ],
    prepTime: '15 min',
    cookTime: '25 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Omelette-espagnole.webp',
    category: 'Plat principal',
  },

  {
    id: 'soupe_champignons',
    name: 'Soupe à la crème de champignons',
    nameArabic: 'شوربة كريمة الفطر',
    ingredients: [
      '500g de champignons de Paris',
      '1 oignon',
      '2 gousses d\'ail',
      '200ml de crème fraîche',
      '1L de bouillon de volaille',
      '50g de beurre',
      '2 cuillères à soupe de farine',
      'persil frais',
      'sel et poivre',
    ],
    instructions: [
      'Nettoyer et émincer les champignons.',
      'Faire revenir l\'oignon et l\'ail dans le beurre.',
      'Ajouter les champignons et cuire jusqu\'à évaporation.',
      'Saupoudrer de farine et ajouter le bouillon.',
      'Mixer, ajouter la crème et assaisonner.',
    ],
    instructionDetails: [
      'Nettoyer les champignons et les émincer finement. Hacher l\'oignon et l\'ail.',
      'Dans une grande casserole, faire fondre le beurre et faire revenir l\'oignon et l\'ail.',
      'Ajouter les champignons et cuire à feu vif jusqu\'à évaporation de l\'eau de végétation.',
      'Saupoudrer de farine, mélanger puis verser progressivement le bouillon chaud.',
      'Laisser mijoter 15 minutes, mixer partiellement, ajouter la crème, assaisonner et parsemer de persil.',
    ],
    prepTime: '15 min',
    cookTime: '20 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Soupe-a-la-creme-de-champignons.webp',
    category: 'Entrée',
  },

  {
    id: 'croque_monsieur',
    name: 'Croque-monsieur',
    nameArabic: 'كروك مسيو',
    ingredients: [
      '8 tranches de pain de mie',
      '4 tranches de paté',
      '200g de gruyère râpé',
      '50g de beurre',
      '2 cuillères à soupe de farine',
      '300ml de lait',
      'noix de muscade',
      'sel et poivre',
    ],
    instructions: [
      'Préparer une béchamel avec le beurre, la farine et le lait.',
      'Assaisonner avec sel, poivre et muscade.',
      'Tartiner les tranches de pain avec la béchamel.',
      'Ajouter le paté fumé ou et le fromage entre deux tranches.',
      'Recouvrir de béchamel et de fromage, gratiner au four.',
    ],
    instructionDetails: [
      'Dans une casserole, faire fondre le beurre, ajouter la farine et cuire 2 minutes. Verser le lait progressivement.',
      'Assaisonner la béchamel avec sel, poivre et une pincée de muscade.',
      'Tartiner légèrement chaque tranche de pain avec la béchamel.',
      'Garnir de paté fumé et de fromage râpé, refermer avec une autre tranche.',
      'Recouvrir le dessus de béchamel et de fromage, gratiner à 200°C pendant 10-15 minutes.',
    ],
    prepTime: '15 min',
    cookTime: '15 min',
    difficulty: 'Facile',
    imageUrl: 'https://images.unsplash.com/photo-1528735602780-2552fd46c7af?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    category: 'Plat principal',
  },

  {
    id: 'pancakes',
    name: 'Pancakes',
    nameArabic: 'بان كيك',
    ingredients: [
      '200g de farine',
      '2 œufs',
      '300ml de lait',
      '2 cuillères à soupe de sucre',
      '1 sachet de levure chimique',
      '1 pincée de sel',
      'beurre pour la cuisson',
      'sirop d\'érable ou miel',
    ],
    instructions: [
      'Mélanger les ingrédients secs dans un bol.',
      'Battre les œufs avec le lait dans un autre bol.',
      'Incorporer les liquides aux ingrédients secs.',
      'Laisser reposer la pâte 10 minutes.',
      'Cuire les pancakes dans une poêle beurrée.',
    ],
    instructionDetails: [
      'Dans un grand bol, mélanger farine, sucre, levure et sel.',
      'Dans un autre bol, battre les œufs et ajouter le lait.',
      'Verser les liquides sur les ingrédients secs et mélanger jusqu\'à obtenir une pâte lisse.',
      'Laisser reposer la pâte pour que la levure agisse.',
      'Chauffer une poêle avec un peu de beurre, verser une louche de pâte et cuire 2-3 minutes de chaque côté.',
    ],
    prepTime: '10 min',
    cookTime: '15 min',
    difficulty: 'Facile',
    imageUrl: 'https://images.unsplash.com/photo-1567620905732-2d1ec7ab7445?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    category: 'Dessert',
  },

  {
    id: 'tacos_rapides',
    name: 'Tacos rapides',
    nameArabic: 'تاكوس سريع',
    ingredients: [
      '8 tortillas de blé',
      '400g de viande hachée',
      '1 oignon',
      '2 tomates',
      '1 avocat',
      '200g de cheddar râpé',
      'salade iceberg',
      'crème fraîche',
      'épices mexicaines',
      'huile d\'olive',
    ],
    instructions: [
      'Faire revenir l\'oignon et la viande hachée.',
      'Assaisonner avec les épices mexicaines.',
      'Réchauffer les tortillas à la poêle.',
      'Préparer les garnitures : tomates, avocat, salade.',
      'Garnir les tortillas et servir immédiatement.',
    ],
    instructionDetails: [
      'Dans une poêle, faire revenir l\'oignon haché puis ajouter la viande hachée.',
      'Assaisonner avec les épices mexicaines, sel et poivre. Cuire jusqu\'à ce que la viande soit bien dorée.',
      'Réchauffer les tortillas dans une poêle sèche ou au micro-ondes.',
      'Couper les tomates en dés, l\'avocat en lamelles, ciseler la salade.',
      'Garnir chaque tortilla de viande, légumes, fromage et crème fraîche. Plier et servir.',
    ],
    prepTime: '15 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/french-Tacos.webp',
    category: 'Plat principal',
  },

  {
    id: 'wrap_poulet',
    name: 'Wrap au poulet',
    nameArabic: 'راب بالدجاج',
    ingredients: [
      '4 tortillas de blé',
      '2 blancs de poulet',
      '1 poivron rouge',
      '1 concombre',
      '2 tomates',
      'salade verte',
      '4 cuillères à soupe de mayonnaise',
      '1 cuillère à soupe de moutarde',
      'épices (paprika, cumin)',
      'huile d\'olive',
    ],
    instructions: [
      'Cuire les blancs de poulet avec les épices.',
      'Découper le poulet en lamelles.',
      'Préparer les légumes en julienne.',
      'Mélanger mayonnaise et moutarde pour la sauce.',
      'Garnir les tortillas et rouler en wrap.',
    ],
    instructionDetails: [
      'Faire cuire les blancs de poulet dans une poêle avec un peu d\'huile et les épices.',
      'Laisser refroidir puis découper en fines lamelles.',
      'Couper le poivron, concombre et tomates en julienne ou en dés.',
      'Préparer une sauce en mélangeant mayonnaise et moutarde.',
      'Étaler la sauce sur les tortillas, ajouter salade, poulet et légumes. Rouler fermement.',
    ],
    prepTime: '15 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://images.unsplash.com/photo-1626700051175-6818013e1d4f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    category: 'Plat principal',
  },

  {
    id: 'riz_frit_oeuf',
    name: 'Riz frit à l\'œuf',
    nameArabic: 'أرز مقلي بالبيض',
    ingredients: [
      '300g de riz cuit (de préférence de la veille)',
      '3 œufs',
      '2 oignons verts',
      '2 gousses d\'ail',
      '1 carotte',
      '100g de petits pois',
      '3 cuillères à soupe de sauce soja',
      '2 cuillères à soupe d\'huile de sésame',
      'huile végétale',
      'sel et poivre',
    ],
    instructions: [
      'Battre les œufs et les cuire en omelette.',
      'Faire revenir l\'ail et les légumes.',
      'Ajouter le riz cuit et mélanger.',
      'Incorporer l\'omelette coupée en morceaux.',
      'Assaisonner avec la sauce soja et l\'huile de sésame.',
    ],
    instructionDetails: [
      'Battre les œufs et les cuire en omelette dans une poêle. Réserver et couper en lamelles.',
      'Dans un wok ou une grande poêle, faire revenir l\'ail haché, la carotte en dés et les petits pois.',
      'Ajouter le riz cuit froid et mélanger vigoureusement pour bien séparer les grains.',
      'Incorporer les morceaux d\'omelette et les oignons verts hachés.',
      'Assaisonner avec la sauce soja, l\'huile de sésame, sel et poivre. Servir chaud.',
    ],
    prepTime: '10 min',
    cookTime: '15 min',
    difficulty: 'Facile',
    imageUrl: 'https://images.unsplash.com/photo-1603133872878-684f208fb84b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    category: 'Plat principal',
  },

  {
    id: 'quiche_sans_pate',
    name: 'Quiche sans pâte',
    nameArabic: 'كيش بدون عجين',
    ingredients: [
      '6 œufs',
      '200ml de crème fraîche',
      '100ml de lait',
      '200g de paté fumé',
      '150g de gruyère râpé',
      '1 oignon',
      '200g d\'épinards',
      'noix de muscade',
      'sel et poivre',
      'beurre pour le moule',
    ],
    instructions: [
      'Faire revenir les lardons et l\'oignon.',
      'Ajouter les épinards et cuire jusqu\'à évaporation.',
      'Battre les œufs avec la crème et le lait.',
      'Mélanger tous les ingrédients avec le fromage.',
      'Verser dans un moule beurré et cuire 35 minutes.',
    ],
    instructionDetails: [
      'Dans une poêle, faire revenir les lardons puis ajouter l\'oignon haché.',
      'Ajouter les épinards et cuire jusqu\'à évaporation de l\'eau. Laisser refroidir.',
      'Dans un bol, battre les œufs avec la crème, le lait, sel, poivre et muscade.',
      'Mélanger la préparation aux œufs avec les lardons, épinards et fromage râpé.',
      'Verser dans un moule à tarte beurré et cuire à 180°C pendant 35 minutes.',
    ],
    prepTime: '15 min',
    cookTime: '35 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Quiche-sans-pate.webp',
    category: 'Plat principal',
  },

  {
    id: 'salade_pates',
    name: 'Salade de pâtes',
    nameArabic: 'سلطة المعكرونة',
    ingredients: [
      '400g de pâtes courtes (fusilli ou penne)',
      '200g de tomates cerises',
      '150g de mozzarella',
      '100g d\'olives noires',
      '1 poivron rouge',
      '1 concombre',
      'basilic frais',
      '4 cuillères à soupe d\'huile d\'olive',
      '2 cuillères à soupe de vinaigre balsamique',
      'sel et poivre',
    ],
    instructions: [
      'Cuire les pâtes selon les instructions du paquet.',
      'Couper tous les légumes en morceaux.',
      'Préparer la vinaigrette avec huile et vinaigre.',
      'Mélanger les pâtes refroidies avec les légumes.',
      'Assaisonner et ajouter la mozzarella et le basilic.',
    ],
    instructionDetails: [
      'Cuire les pâtes dans une grande casserole d\'eau bouillante salée. Égoutter et rincer à l\'eau froide.',
      'Couper les tomates cerises en deux, le poivron en dés, le concombre en rondelles.',
      'Préparer une vinaigrette en mélangeant huile d\'olive, vinaigre balsamique, sel et poivre.',
      'Dans un grand saladier, mélanger les pâtes avec tous les légumes et les olives.',
      'Ajouter la mozzarella coupée en cubes, la vinaigrette et le basilic ciselé. Réfrigérer avant de servir.',
    ],
    prepTime: '20 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Salade-de-pates.webp',
    category: 'Entrée',
  },

  {
    id: 'burger_maison',
    name: 'Burger maison',
    nameArabic: 'برغر منزلي',
    ingredients: [
      '4 pains à burger',
      '600g de viande hachée',
      '4 tranches de cheddar',
      '2 tomates',
      '1 oignon rouge',
      'salade iceberg',
      '4 cornichons',
      'ketchup',
      'mayonnaise',
      'moutarde',
      'sel et poivre',
    ],
    instructions: [
      'Former 4 steaks avec la viande hachée.',
      'Cuire les steaks dans une poêle chaude.',
      'Faire griller les pains à burger.',
      'Préparer les garnitures : tomates, oignon, salade.',
      'Assembler les burgers avec toutes les garnitures.',
    ],
    instructionDetails: [
      'Former 4 steaks de même taille avec la viande hachée, assaisonner avec sel et poivre.',
      'Cuire les steaks dans une poêle bien chaude, 3-4 minutes de chaque côté. Ajouter le fromage en fin de cuisson.',
      'Faire griller les pains coupés en deux dans la même poêle.',
      'Couper les tomates en rondelles, l\'oignon rouge en anneaux, laver la salade.',
      'Assembler : pain du bas, sauce, salade, steak au fromage, tomate, oignon, cornichon, sauces, pain du haut.',
    ],
    prepTime: '15 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://images.unsplash.com/photo-1568901346375-23c9450c58cd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    category: 'Plat principal',
  },

  {
    id: 'curry_pois_chiches',
    name: 'Curry de pois chiches',
    nameArabic: 'كاري الحمص',
    ingredients: [
      '400g de pois chiches en conserve',
      '400ml de lait de coco',
      '2 tomates',
      '1 oignon',
      '3 gousses d\'ail',
      '1 morceau de gingembre',
      '2 cuillères à soupe de pâte de curry',
      '1 cuillère à café de curcuma',
      '1 cuillère à café de cumin',
      'coriandre fraîche',
      'huile d\'olive',
      'sel',
    ],
    instructions: [
      'Faire revenir l\'oignon, l\'ail et le gingembre.',
      'Ajouter les épices et la pâte de curry.',
      'Incorporer les tomates et cuire jusqu\'à réduction.',
      'Ajouter les pois chiches et le lait de coco.',
      'Laisser mijoter 15 minutes et parsemer de coriandre.',
    ],
    instructionDetails: [
      'Dans une grande poêle, faire revenir l\'oignon haché, l\'ail et le gingembre râpé dans l\'huile.',
      'Ajouter la pâte de curry, le curcuma et le cumin. Cuire 1 minute en remuant.',
      'Ajouter les tomates coupées en dés et cuire jusqu\'à ce qu\'elles se décomposent.',
      'Incorporer les pois chiches égouttés et le lait de coco. Assaisonner avec du sel.',
      'Laisser mijoter 15 minutes à feu doux. Servir avec du riz et parsemer de coriandre fraîche.',
    ],
    prepTime: '15 min',
    cookTime: '20 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Curry-de-pois-chiches.webp',
    category: 'Plat principal',
  },
  {
    id: 'salade-thon-rapide',
    name: 'Salade de thon rapide',
    nameArabic: 'سلطة التونة السريعة',
    ingredients: [
      '2 boîtes de thon à l\'huile',
      '2 tomates',
      '1 concombre',
      '1 oignon rouge',
      '2 œufs durs',
      'Olives noires',
      'Huile d\'olive',
      'Vinaigre',
      'Sel et poivre'
    ],
    instructions: [
      'Égoutter le thon et l\'émietter dans un saladier',
      'Couper les tomates en quartiers et le concombre en rondelles',
      'Émincer finement l\'oignon rouge',
      'Écaler et couper les œufs durs en quartiers',
      'Mélanger tous les ingrédients dans le saladier',
      'Assaisonner avec l\'huile d\'olive, le vinaigre, le sel et le poivre',
      'Décorer avec les olives noires et servir frais'
    ],
    prepTime: '10 min',
    cookTime: '0 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Salade-de-thon-.webp',
    category: 'repas'
  },
  {
    id: 'spaghetti-ail-huile',
    name: 'Spaghetti ail et huile',
    nameArabic: 'سباغيتي بالثوم والزيت',
    ingredients: [
      '400g de spaghetti',
      '6 gousses d\'ail',
      '100ml d\'huile d\'olive extra vierge',
      'Piment rouge séché',
      'Persil frais',
      'Parmesan râpé',
      'Sel'
    ],
    instructions: [
      'Faire cuire les spaghetti dans une grande casserole d\'eau salée bouillante',
      'Pendant ce temps, émincer finement l\'ail',
      'Dans une grande poêle, chauffer l\'huile d\'olive à feu doux',
      'Ajouter l\'ail et le piment, faire revenir 2-3 minutes sans colorer',
      'Égoutter les pâtes en gardant un peu d\'eau de cuisson',
      'Ajouter les spaghetti dans la poêle avec l\'ail',
      'Mélanger en ajoutant un peu d\'eau de cuisson si nécessaire',
      'Parsemer de persil haché et de parmesan, servir immédiatement'
    ],
    prepTime: '5 min',
    cookTime: '12 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Spaghetti-ail-et-huile.webp',
    category: 'repas'
  },
  {
    id: 'pain-perdu-sucre-sale',
    name: 'Pain perdu sucré ou salé',
    nameArabic: 'الخبز المفقود حلو أو مالح',
    ingredients: [
      '6 tranches de pain rassis',
      '3 œufs',
      '200ml de lait',
      'Version sucrée: sucre, vanille, cannelle',
      'Version salée: sel, poivre, herbes de Provence',
      'Beurre pour la cuisson',
      'Fromage râpé (version salée)',
      'Miel ou confiture (version sucrée)'
    ],
    instructions: [
      'Battre les œufs avec le lait dans un plat creux',
      'Pour la version sucrée: ajouter sucre, vanille et cannelle',
      'Pour la version salée: ajouter sel, poivre et herbes',
      'Tremper chaque tranche de pain dans le mélange',
      'Laisser bien imbiber des deux côtés',
      'Chauffer le beurre dans une poêle',
      'Faire dorer les tranches 3-4 minutes de chaque côté',
      'Version sucrée: servir avec miel ou confiture',
      'Version salée: parsemer de fromage râpé avant de servir'
    ],
    prepTime: '10 min',
    cookTime: '8 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Pain-perdu.webp',
    category: 'repas'
  },
  {
    id: 'sandwich-oeuf-dur-tomate',
    name: 'Sandwich œuf dur, tomate & mayonnaise',
    nameArabic: 'ساندويش البيض المسلوق والطماطم والمايونيز',
    ingredients: [
      '4 tranches de pain de mie',
      '3 œufs durs',
      '2 tomates',
      '4 cuillères à soupe de mayonnaise',
      'Salade verte',
      'Sel et poivre',
      'Beurre (optionnel)'
    ],
    instructions: [
      'Faire cuire les œufs dans l\'eau bouillante pendant 10 minutes',
      'Les refroidir dans l\'eau froide puis les écaler',
      'Couper les œufs durs en rondelles',
      'Laver et couper les tomates en tranches',
      'Faire griller légèrement le pain si désiré',
      'Tartiner les tranches de pain avec la mayonnaise',
      'Disposer la salade, les rondelles d\'œuf et les tomates',
      'Assaisonner avec sel et poivre',
      'Refermer les sandwichs et couper en diagonale'
    ],
    prepTime: '15 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Sandwich-oeuf-dur-tomate-mayonnaise.webp',
    category: 'repas'
  },
  {
    id: 'omelette-fromage-herbes',
    name: 'Omelette au fromage et herbes',
    nameArabic: 'عجة الجبن والأعشاب',
    ingredients: [
      '6 œufs',
      '100g de fromage râpé (gruyère ou emmental)',
      '2 cuillères à soupe de crème fraîche',
      'Ciboulette fraîche',
      'Persil frais',
      '30g de beurre',
      'Sel et poivre'
    ],
    instructions: [
      'Casser les œufs dans un saladier',
      'Ajouter la crème fraîche, sel et poivre',
      'Battre énergiquement le mélange',
      'Hacher finement la ciboulette et le persil',
      'Incorporer les herbes et la moitié du fromage aux œufs',
      'Chauffer le beurre dans une poêle antiadhésive',
      'Verser le mélange d\'œufs dans la poêle chaude',
      'Cuire 2-3 minutes puis parsemer du reste de fromage',
      'Plier l\'omelette en deux et servir immédiatement'
    ],
    prepTime: '5 min',
    cookTime: '5 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Omelette-au-fromage-et-herbes.webp',
    category: 'repas'
  },
  {
    id: 'nuggets-poulet-maison',
    name: 'Nuggets de poulet maison',
    nameArabic: 'ناغتس الدجاج المنزلي',
    ingredients: [
      '500g de blanc de poulet',
      '2 œufs',
      '100g de chapelure',
      '50g de farine',
      'Sel et poivre',
      'Paprika',
      'Huile pour friture'
    ],
    instructions: [
      'Couper le poulet en petits morceaux',
      'Préparer 3 assiettes : farine, œufs battus, chapelure',
      'Assaisonner la farine avec sel, poivre et paprika',
      'Passer chaque morceau dans la farine, puis l\'œuf, puis la chapelure',
      'Faire chauffer l\'huile dans une poêle',
      'Faire frire les nuggets 3-4 minutes de chaque côté',
      'Égoutter sur papier absorbant et servir chaud'
    ],
    prepTime: '15 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://images.unsplash.com/photo-1562967914-608f82629710?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    category: 'repas'
  },
  {
    id: 'mini-pizzas-pain-mie',
    name: 'Mini-pizzas sur pain de mie',
    nameArabic: 'بيتزا صغيرة على خبز التوست',
    ingredients: [
      '8 tranches de pain de mie',
      '200ml de sauce tomate',
      '200g de fromage râpé',
      '100g de paté fumé ou simple',
      'Champignons en conserve',
      'Olives noires',
      'Origan',
      'Huile d\'olive'
    ],
    instructions: [
      'Préchauffer le four à 200°C',
      'Disposer les tranches de pain sur une plaque',
      'Badigeonner chaque tranche d\'huile d\'olive',
      'Étaler la sauce tomate sur chaque tranche',
      'Ajouter le fromage râpé',
      'Garnir avec paté, champignons et olives',
      'Saupoudrer d\'origan',
      'Enfourner 8-10 minutes jusqu\'à ce que le fromage soit doré'
    ],
    prepTime: '10 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Mini-pizzas-sur-pain-de-mie.webp',
    category: 'repas'
  },
  {
    id: 'puree-pommes-terre-carottes',
    name: 'Purée de pommes de terre & carottes',
    nameArabic: 'هريس البطاطس والجزر',
    ingredients: [
      '800g de pommes de terre',
      '400g de carottes',
      '50g de beurre',
      '100ml de lait chaud',
      'Sel et poivre',
      'Noix de muscade',
      '1 cuillère à soupe de crème fraîche'
    ],
    instructions: [
      'Éplucher et couper les pommes de terre et carottes en morceaux',
      'Faire bouillir dans une grande casserole d\'eau salée',
      'Cuire 20-25 minutes jusqu\'à ce qu\'ils soient tendres',
      'Égoutter soigneusement',
      'Écraser avec un presse-purée ou une fourchette',
      'Ajouter le beurre et mélanger',
      'Incorporer le lait chaud progressivement',
      'Assaisonner avec sel, poivre et muscade',
      'Ajouter la crème fraîche et servir chaud'
    ],
    prepTime: '15 min',
    cookTime: '25 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Puree-de-pommes-de-terre-et-carottes-1.webp',
    category: 'repas'
  },
  {
    id: 'crepes-sucrees-faciles',
    name: 'Crêpes sucrées faciles',
    nameArabic: 'كريب حلو سهل',
    ingredients: [
      '250g de farine',
      '4 œufs',
      '500ml de lait',
      '2 cuillères à soupe de sucre',
      '1 pincée de sel',
      '2 cuillères à soupe d\'huile',
      'Beurre pour la cuisson',
      'Sucre ou confiture pour servir'
    ],
    instructions: [
      'Mélanger la farine, le sucre et le sel dans un saladier',
      'Faire un puits au centre',
      'Ajouter les œufs et mélanger',
      'Incorporer le lait progressivement pour éviter les grumeaux',
      'Ajouter l\'huile et mélanger',
      'Laisser reposer la pâte 30 minutes',
      'Faire chauffer une poêle avec un peu de beurre',
      'Verser une louche de pâte et étaler',
      'Cuire 1-2 minutes de chaque côté',
      'Servir avec du sucre ou de la confiture'
    ],
    prepTime: '10 min',
    cookTime: '20 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Crepes-sucrees-faciles-1.webp',
    category: 'Dessert'
  },
  {
    id: 'gateau-yaourt',
    name: 'Gâteau au yaourt',
    nameArabic: 'كيكة الياغورت',
    ingredients: [
      '1 yaourt nature (pot de mesure)',
      '2 pots de sucre',
      '3 pots de farine',
      '1/2 pot d\'huile',
      '3 œufs',
      '1 sachet de levure chimique',
      '1 sachet de sucre vanillé',
      'Zeste d\'un citron (optionnel)'
    ],
    instructions: [
      'Préchauffer le four à 180°C',
      'Beurrer et fariner un moule à cake',
      'Vider le yaourt dans un saladier (garder le pot)',
      'Ajouter les œufs et mélanger',
      'Incorporer le sucre et le sucre vanillé',
      'Ajouter l\'huile et mélanger',
      'Mélanger farine et levure, puis incorporer',
      'Ajouter le zeste de citron si désiré',
      'Verser dans le moule',
      'Enfourner 35-40 minutes',
      'Vérifier la cuisson avec un couteau'
    ],
    prepTime: '10 min',
    cookTime: '40 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Gateau-au-yaourt-1.webp',
    category: 'Dessert'
  },
  {
    id: 'mug-cake-micro-ondes',
    name: 'Gâteau au micro-ondes (mug cake)',
    nameArabic: 'كيكة الكوب في الميكروويف',
    ingredients: [
      '1 œuf',
      '3 cuillères à soupe de sucre',
      '3 cuillères à soupe de farine',
      '2 cuillères à soupe d\'huile',
      '2 cuillères à soupe de lait',
      '1/2 cuillère à café de levure chimique',
      '1 cuillère à soupe de cacao en poudre (optionnel)'
    ],
    instructions: [
      'Dans une grande tasse ou un mug, battre l\'œuf avec une fourchette',
      'Ajouter le sucre et mélanger',
      'Incorporer l\'huile et le lait',
      'Ajouter la farine, la levure et le cacao (si désiré)',
      'Bien mélanger jusqu\'à obtenir une pâte lisse',
      'Cuire au micro-ondes pendant 1 minute 30 à 2 minutes selon la puissance'
    ],
    instructionDetails: [
      'Utiliser une tasse assez grande car le gâteau va gonfler',
      'Le sucre peut être ajusté selon vos goûts',
      'L\'huile peut être remplacée par du beurre fondu',
      'Pour un mug cake nature, omettre le cacao',
      'La pâte doit être homogène sans grumeaux',
      'Surveiller la cuisson, le gâteau est prêt quand il a gonflé et qu\'un cure-dent ressort propre'
    ],
    prepTime: '3 min',
    cookTime: '2 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/mug-cake.webp',
    category: 'Dessert'
  },
  {
    id: 'riz-au-lait-traditionnel',
    name: 'Riz au lait',
    nameArabic: 'رز بالحليب',
    ingredients: [
      '100g de riz rond',
      '1 litre de lait entier',
      '80g de sucre',
      '1 gousse de vanille',
      '1 pincée de sel',
      'Cannelle en poudre pour décorer'
    ],
    instructions: [
      'Rincer le riz à l\'eau froide jusqu\'à ce que l\'eau soit claire',
      'Dans une casserole, porter le lait à ébullition avec la gousse de vanille fendue',
      'Ajouter le riz et une pincée de sel',
      'Cuire à feu doux en remuant régulièrement pendant 25-30 minutes',
      'Ajouter le sucre en fin de cuisson',
      'Retirer la gousse de vanille et servir tiède ou froid',
      'Saupoudrer de cannelle avant de servir'
    ],
    instructionDetails: [
      'Le rinçage du riz permet d\'éliminer l\'amidon en excès',
      'Gratter les graines de vanille dans le lait pour plus de saveur',
      'Remuer régulièrement pour éviter que le riz colle au fond',
      'Le riz doit être tendre et crémeux',
      'Ajuster la quantité de sucre selon vos préférences',
      'La vanille peut être remplacée par de l\'extrait de vanille',
      'Peut être servi avec des fruits ou de la confiture'
    ],
    prepTime: '5 min',
    cookTime: '35 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Riz-au-lait.webp',
    category: 'Dessert'
  },
  {
    id: 'mousse-chocolat-3-ingredients',
    name: 'Mousse au chocolat 3 ingrédients',
    nameArabic: 'موس الشوكولاتة بثلاث مكونات',
    ingredients: [
      '200g de chocolat noir',
      '6 œufs',
      '1 pincée de sel'
    ],
    instructions: [
      'Faire fondre le chocolat au bain-marie ou au micro-ondes',
      'Séparer les blancs des jaunes d\'œufs',
      'Mélanger les jaunes d\'œufs avec le chocolat fondu tiède',
      'Monter les blancs en neige ferme avec une pincée de sel',
      'Incorporer délicatement les blancs au mélange chocolat en 2 fois',
      'Répartir dans des verrines et réfrigérer au moins 2 heures'
    ],
    instructionDetails: [
      'Le chocolat ne doit pas être trop chaud pour ne pas cuire les jaunes',
      'Bien séparer les blancs des jaunes, aucune trace de jaune dans les blancs',
      'Mélanger rapidement les jaunes au chocolat pour éviter qu\'ils cuisent',
      'Les blancs doivent être bien fermes pour donner de la légèreté',
      'Incorporer les blancs avec une spatule en mouvements de bas en haut',
      'Plus la mousse repose longtemps, plus elle sera ferme'
    ],
    prepTime: '15 min',
    cookTime: '5 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/mousse-au-chocolat-3.webp',
    category: 'Dessert'
  },
  {
    id: 'creme-dessert-vanille',
    name: 'Crème dessert vanille',
    nameArabic: 'كريمة الفانيليا',
    ingredients: [
      '500ml de lait',
      '3 jaunes d\'œufs',
      '60g de sucre',
      '30g de maïzena',
      '1 gousse de vanille',
      '20g de beurre'
    ],
    instructions: [
      'Faire chauffer le lait avec la gousse de vanille fendue',
      'Dans un bol, blanchir les jaunes avec le sucre',
      'Ajouter la maïzena et mélanger',
      'Verser le lait chaud en remuant constamment',
      'Remettre le mélange dans la casserole et cuire en remuant jusqu\'à épaississement',
      'Hors du feu, ajouter le beurre et mélanger',
      'Verser dans des pots et laisser refroidir'
    ],
    instructionDetails: [
      'Gratter les graines de vanille dans le lait',
      'Blanchir signifie fouetter jusqu\'à ce que le mélange blanchisse',
      'Bien délayer la maïzena pour éviter les grumeaux',
      'Verser le lait progressivement en fouettant',
      'Cuire à feu moyen en remuant sans arrêt pour éviter que ça accroche',
      'Le beurre apporte de la brillance et de l\'onctuosité',
      'Filmer au contact pour éviter la formation d\'une peau'
    ],
    prepTime: '10 min',
    cookTime: '10 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Creme-dessert-vanille.webp',
    category: 'Dessert'
  },
  {
    id: 'beignets-rapides-sans-levee',
    name: 'Beignets rapides (sans levée)',
    nameArabic: 'دونات سريعة بدون خميرة',
    ingredients: [
      '250g de farine',
      '1 œuf',
      '200ml de lait',
      '50g de sucre',
      '1 sachet de levure chimique',
      '1 pincée de sel',
      '2 cuillères à soupe d\'huile',
      'Huile pour friture',
      'Sucre glace pour saupoudrer'
    ],
    instructions: [
      'Mélanger la farine, le sucre, la levure et le sel dans un saladier',
      'Battre l\'œuf avec le lait et l\'huile',
      'Incorporer les liquides aux ingrédients secs',
      'Mélanger jusqu\'à obtenir une pâte lisse',
      'Chauffer l\'huile à 170°C',
      'Former des beignets avec 2 cuillères et les plonger dans l\'huile',
      'Cuire 2-3 minutes de chaque côté jusqu\'à ce qu\'ils soient dorés',
      'Égoutter sur papier absorbant et saupoudrer de sucre glace'
    ],
    instructionDetails: [
      'Tamiser la farine pour éviter les grumeaux',
      'Ne pas trop battre la pâte pour garder des beignets moelleux',
      'La pâte doit être assez épaisse pour tenir sur la cuillère',
      'Vérifier la température de l\'huile avec un thermomètre',
      'Ne pas surcharger la friteuse pour maintenir la température',
      'Les beignets doivent remonter à la surface quand ils sont cuits',
      'Retourner délicatement avec une écumoire',
      'Servir tiède pour plus de gourmandise'
    ],
    prepTime: '10 min',
    cookTime: '15 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Beignets-rapides.webp',
    category: 'Dessert'
  },
  {
    id: 'soupe-lentilles',
    name: 'Soupe aux lentilles',
    nameArabic: 'شوربة العدس',
    ingredients: [
      '200g de lentilles rouges',
      '1 oignon moyen',
      '2 gousses d\'ail',
      '1 carotte',
      '1 branche de céleri',
      '1 litre de bouillon de légumes',
      '1 cuillère à café de cumin',
      '1 cuillère à café de curcuma',
      'Sel et poivre',
      '2 cuillères à soupe d\'huile d\'olive',
      'Persil frais pour la garniture'
    ],
    instructions: [
      'Rincer les lentilles à l\'eau froide et les égoutter.',
      'Éplucher et hacher finement l\'oignon, l\'ail, la carotte et le céleri.',
      'Dans une grande casserole, faire chauffer l\'huile d\'olive à feu moyen.',
      'Faire revenir l\'oignon jusqu\'à ce qu\'il soit translucide (5 minutes).',
      'Ajouter l\'ail, la carotte et le céleri, cuire 3 minutes.',
      'Incorporer les lentilles, le cumin et le curcuma, mélanger 1 minute.',
      'Verser le bouillon, porter à ébullition puis réduire le feu.',
      'Laisser mijoter 20-25 minutes jusqu\'à ce que les lentilles soient tendres.',
      'Mixer partiellement pour obtenir une texture crémeuse mais avec des morceaux.',
      'Assaisonner avec sel et poivre, servir chaud avec du persil.'
    ],
    instructionDetails: [
      'Les lentilles rouges cuisent plus rapidement que les vertes.',
      'Une brunoise fine assure une cuisson homogène.',
      'L\'huile d\'olive apporte de la saveur à la base aromatique.',
      'La cuisson lente développe les saveurs.',
      'Les légumes apportent de la texture et des vitamines.',
      'Les épices parfument délicatement la soupe.',
      'Le bouillon doit être de bonne qualité pour un goût optimal.',
      'Le temps de cuisson peut varier selon la variété de lentilles.',
      'Le mixage partiel donne une texture agréable.',
      'Le persil frais apporte de la fraîcheur et de la couleur.'
    ],
    prepTime: '15 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Soupe-aux-lentilles.webp',
    category: 'Plat Principal'
  },
  {
    id: 'puree-oeuf-poche',
    name: 'Purée + œuf poché',
    nameArabic: 'بوريه مع بيضة مسلوقة',
    ingredients: [
      '800g de pommes de terre',
      '4 œufs très frais',
      '100ml de lait chaud',
      '50g de beurre',
      '1 cuillère à soupe de vinaigre blanc',
      'Sel et poivre',
      'Ciboulette fraîche',
      'Paprika pour la décoration'
    ],
    instructions: [
      'Éplucher et couper les pommes de terre en morceaux.',
      'Les cuire dans l\'eau salée bouillante 20 minutes.',
      'Pendant ce temps, porter une casserole d\'eau à ébullition avec le vinaigre.',
      'Écraser les pommes de terre avec le beurre et le lait chaud.',
      'Assaisonner la purée avec sel et poivre, garder au chaud.',
      'Casser chaque œuf dans un petit bol.',
      'Créer un tourbillon dans l\'eau bouillante et y glisser délicatement un œuf.',
      'Cuire 3-4 minutes pour un jaune coulant.',
      'Répéter l\'opération pour chaque œuf.',
      'Servir la purée chaude surmontée de l\'œuf poché, parsemer de ciboulette.'
    ],
    instructionDetails: [
      'Choisir des pommes de terre farineuses pour une purée onctueuse.',
      'La cuisson doit être complète pour éviter les grumeaux.',
      'Le vinaigre aide à coaguler le blanc d\'œuf.',
      'Le lait chaud évite de refroidir la purée.',
      'Une purée bien assaisonnée est essentielle.',
      'Des œufs très frais donnent de meilleurs résultats.',
      'Le tourbillon maintient le blanc autour du jaune.',
      'Le temps de cuisson détermine la consistance du jaune.',
      'Égoutter délicatement les œufs pochés.',
      'Servir immédiatement pour profiter de la chaleur.'
    ],
    prepTime: '10 min',
    cookTime: '25 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Puree-oeuf-poche.webp',
    category: 'Plat Principal'
  },
  {
    id: 'gratin-pommes-terre-sans-creme',
    name: 'Gratin de pommes de terre sans crème',
    nameArabic: 'غراتان البطاطس بدون كريمة',
    ingredients: [
      '1kg de pommes de terre',
      '300ml de lait entier',
      '100g de fromage râpé (gruyère)',
      '2 gousses d\'ail',
      '30g de beurre',
      'Noix de muscade',
      'Sel et poivre',
      'Thym frais',
      '1 oignon (optionnel)'
    ],
    instructions: [
      'Préchauffer le four à 180°C.',
      'Éplucher et couper les pommes de terre en rondelles fines (2-3mm).',
      'Frotter un plat à gratin avec l\'ail puis le beurrer.',
      'Disposer les rondelles de pommes de terre en couches dans le plat.',
      'Assaisonner chaque couche avec sel, poivre et muscade.',
      'Faire chauffer le lait avec l\'ail écrasé et le thym.',
      'Verser le lait chaud sur les pommes de terre.',
      'Parsemer de fromage râpé sur le dessus.',
      'Enfourner 45-50 minutes jusqu\'à ce que le dessus soit doré.',
      'Laisser reposer 5 minutes avant de servir.'
    ],
    instructionDetails: [
      'Des rondelles uniformes assurent une cuisson homogène.',
      'L\'ail parfume délicatement le plat.',
      'Superposer les couches comme des tuiles.',
      'L\'assaisonnement entre les couches est important.',
      'Le lait infusé apporte plus de saveur.',
      'Le lait doit juste recouvrir les pommes de terre.',
      'Le fromage forme une belle croûte dorée.',
      'Vérifier la cuisson avec la pointe d\'un couteau.',
      'Le repos permet au gratin de se tenir.',
      'Servir bien chaud en accompagnement.'
    ],
    prepTime: '20 min',
    cookTime: '50 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Gratin-de-pommes-de-terre.webp',
    category: 'Plat Principal'
  },
  {
    id: 'brochettes-poulet-marinees',
    name: 'Brochettes de poulet marinées',
    nameArabic: 'أسياخ الدجاج المتبلة',
    ingredients: [
      '600g de blanc de poulet',
      '2 cuillères à soupe d\'huile d\'olive',
      '2 cuillères à soupe de jus de citron',
      '2 gousses d\'ail hachées',
      '1 cuillère à café de paprika',
      '1 cuillère à café de cumin',
      '1 cuillère à café d\'origan',
      'Sel et poivre',
      '1 poivron rouge',
      '1 courgette',
      'Brochettes en bois'
    ],
    instructions: [
      'Couper le poulet en cubes de 3cm environ.',
      'Mélanger huile, citron, ail et toutes les épices dans un bol.',
      'Ajouter les cubes de poulet et bien mélanger.',
      'Laisser mariner au réfrigérateur 2 heures minimum.',
      'Couper les légumes en morceaux de même taille que le poulet.',
      'Faire tremper les brochettes en bois 30 minutes dans l\'eau.',
      'Enfiler alternativement poulet et légumes sur les brochettes.',
      'Préchauffer le grill ou la plancha.',
      'Cuire les brochettes 12-15 minutes en les retournant régulièrement.',
      'Servir chaud avec du riz ou une salade.'
    ],
    instructionDetails: [
      'Des cubes uniformes assurent une cuisson homogène.',
      'La marinade attendrit la viande et apporte du goût.',
      'Plus la marinade est longue, plus c\'est savoureux.',
      'Les légumes apportent couleur et vitamines.',
      'Tremper les brochettes évite qu\'elles brûlent.',
      'Alterner les ingrédients pour un bel aspect.',
      'Une cuisson à feu moyen-vif est idéale.',
      'Retourner régulièrement pour une cuisson uniforme.',
      'Vérifier que le poulet est bien cuit à cœur.',
      'Accompagner de sauce yaourt ou tzatziki.'
    ],
    prepTime: '15 min',
    cookTime: '15 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Brochettes-de-poulet-marinees.webp',
    category: 'Plat Principal'
  },
  {
    id: 'cotelettes-agneau-grillees',
    name: 'Côtelettes d\'agneau grillées',
    nameArabic: 'قطع لحم الخروف المشوية',
    ingredients: [
      '8 côtelettes d\'agneau',
      '3 cuillères à soupe d\'huile d\'olive',
      '2 gousses d\'ail hachées',
      '2 branches de romarin frais',
      '1 cuillère à soupe de miel',
      '1 cuillère à café de moutarde de Dijon',
      'Sel et poivre noir',
      'Fleur de sel pour finir',
      'Citron pour servir'
    ],
    instructions: [
      'Sortir les côtelettes du réfrigérateur 30 minutes avant cuisson.',
      'Mélanger huile, ail, romarin haché, miel et moutarde.',
      'Badigeonner les côtelettes avec cette marinade.',
      'Assaisonner généreusement avec sel et poivre.',
      'Laisser mariner 30 minutes à température ambiante.',
      'Préchauffer le grill ou la plancha à feu vif.',
      'Griller les côtelettes 3-4 minutes de chaque côté pour une cuisson rosée.',
      'Laisser reposer 5 minutes sous papier aluminium.',
      'Parsemer de fleur de sel et servir avec des quartiers de citron.',
      'Accompagner de légumes grillés ou de ratatouille.'
    ],
    instructionDetails: [
      'La viande à température ambiante cuit plus uniformément.',
      'Le miel caramélise et donne une belle couleur.',
      'La moutarde apporte du piquant et aide à la marinade.',
      'Un bon assaisonnement est essentiel pour l\'agneau.',
      'La marinade courte suffit pour cette viande tendre.',
      'Un grill très chaud saisit bien la viande.',
      'Adapter le temps selon l\'épaisseur des côtelettes.',
      'Le repos permet aux jus de se redistribuer.',
      'La fleur de sel apporte une touche finale.',
      'L\'agneau se marie bien avec les légumes méditerranéens.'
    ],
    prepTime: '10 min',
    cookTime: '8 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Cotelettes-agneau-grillees.webp',
    category: 'Plat Principal'
  },
  {
    id: 'poivrons-grilles-farcis',
    name: 'Poivrons grillés farcis',
    nameArabic: 'فلفل مشوي محشي',
    ingredients: [
      '4 gros poivrons rouges',
      '300g de viande hachée (bœuf ou agneau)',
      '100g de riz cuit',
      '1 oignon haché',
      '2 tomates hachées',
      '2 gousses d\'ail',
      '1 cuillère à café de cannelle',
      '1 cuillère à café de piment doux',
      'Persil et menthe fraîche',
      'Sel et poivre',
      'Huile d\'olive'
    ],
    instructions: [
      'Griller les poivrons entiers jusqu\'à ce que la peau noircisse.',
      'Les placer dans un sac plastique 10 minutes puis les peler.',
      'Couper délicatement le haut et retirer les graines.',
      'Faire revenir l\'oignon dans l\'huile jusqu\'à transparence.',
      'Ajouter la viande hachée et cuire jusqu\'à coloration.',
      'Incorporer tomates, ail, épices et herbes, cuire 5 minutes.',
      'Mélanger avec le riz cuit et assaisonner.',
      'Farcir délicatement les poivrons avec ce mélange.',
      'Disposer dans un plat huilé et enfourner 25 minutes à 180°C.',
      'Servir chaud avec du yaourt ou une salade.'
    ],
    instructionDetails: [
      'Griller uniformément pour faciliter l\'épluchage.',
      'La vapeur dans le sac aide à décoller la peau.',
      'Manipuler délicatement pour ne pas percer.',
      'Une base aromatique bien cuite est importante.',
      'Bien colorer la viande pour développer les saveurs.',
      'Les épices parfument délicatement la farce.',
      'Le riz absorbe les jus de cuisson.',
      'Ne pas trop tasser la farce.',
      'L\'huile dans le plat évite que ça accroche.',
      'Vérifier que les poivrons sont tendres.'
    ],
    prepTime: '30 min',
    cookTime: '40 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Poivrons-grilles-farcis.webp',
    category: 'Plat Principal'
  },
  {
    id: 'salade-mechouia',
    name: 'Salade mechouia',
    nameArabic: 'سلطة مشوية',
    ingredients: [
      '4 poivrons (rouge et vert)',
      '4 tomates moyennes',
      '2 oignons',
      '4 gousses d\'ail',
      '2 piments forts (optionnel)',
      '4 cuillères à soupe d\'huile d\'olive',
      '1 cuillère à soupe de vinaigre',
      '1 cuillère à café de carvi moulu',
      'Sel',
      'Olives noires pour décorer',
      'Thon en conserve (optionnel)'
    ],
    instructions: [
      'Griller tous les légumes (poivrons, tomates, oignons, ail) sur feu vif.',
      'Retourner régulièrement jusqu\'à ce que la peau soit bien grillée.',
      'Laisser refroidir puis peler tous les légumes.',
      'Épépiner les tomates et les poivrons.',
      'Hacher grossièrement tous les légumes au couteau.',
      'Mélanger dans un saladier avec l\'huile d\'olive.',
      'Ajouter le vinaigre, le carvi et le sel.',
      'Laisser macérer 2 heures au réfrigérateur.',
      'Décorer avec les olives noires avant de servir.',
      'Accompagner de pain grillé ou servir en entrée.'
    ],
    instructionDetails: [
      'Griller sur barbecue ou à la flamme du gaz pour plus d\'authenticité.',
      'Bien griller pour développer les saveurs fumées.',
      'Peler à chaud est plus facile.',
      'Retirer les graines évite l\'amertume.',
      'Hacher à la main préserve la texture.',
      'L\'huile d\'olive de qualité est essentielle.',
      'Le carvi est l\'épice traditionnelle de ce plat.',
      'La macération développe les saveurs.',
      'Les olives apportent du caractère.',
      'Excellent avec du pain traditionnel ou des œufs durs.'
    ],
    prepTime: '20 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Salade-mechouia.webp',
    category: 'Entrée'
  },
  {
    id: 'ailes-poulet-piquantes',
    name: 'Ailes de poulet piquantes',
    nameArabic: 'أجنحة الدجاج الحارة',
    ingredients: [
      '1kg d\'ailes de poulet',
      '3 cuillères à soupe de sauce soja',
      '2 cuillères à soupe de miel',
      '2 cuillères à soupe de ketchup',
      '1 cuillère à soupe de sauce piquante',
      '2 gousses d\'ail hachées',
      '1 cuillère à café de gingembre râpé',
      '1 cuillère à café de paprika fumé',
      'Sel et poivre',
      'Graines de sésame',
      'Ciboulette pour décorer'
    ],
    instructions: [
      'Nettoyer et sécher les ailes de poulet.',
      'Mélanger sauce soja, miel, ketchup et sauce piquante.',
      'Ajouter ail, gingembre, paprika, sel et poivre.',
      'Enrober les ailes avec cette marinade.',
      'Laisser mariner 2 heures au réfrigérateur.',
      'Préchauffer le four à 200°C.',
      'Disposer les ailes sur une plaque recouverte de papier sulfurisé.',
      'Enfourner 35-40 minutes en retournant à mi-cuisson.',
      'Badigeonner avec le reste de marinade pendant la cuisson.',
      'Parsemer de graines de sésame et ciboulette avant de servir.'
    ],
    instructionDetails: [
      'Bien sécher les ailes pour une meilleure adhérence.',
      'L\'équilibre sucré-salé-piquant est important.',
      'Le gingembre frais apporte plus de saveur.',
      'Plus la marinade est longue, plus c\'est goûteux.',
      'Une température élevée donne une peau croustillante.',
      'Le papier sulfurisé évite que ça accroche.',
      'Retourner pour une cuisson uniforme.',
      'Badigeonner régulièrement pour la couleur.',
      'Vérifier que la chair n\'est plus rosée.',
      'Servir immédiatement pour garder le croustillant.'
    ],
    prepTime: '15 min',
    cookTime: '40 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Ailes-de-poulet-piquantes.webp',
    category: 'Plat Principal'
  },


  {
    id: 'gratin_dauphinois',
    name: 'Gratin dauphinois',
    nameArabic: 'غراتان دوفينوا',
    ingredients: [
      '1 kg de pommes de terre',
      '50 cl de crème fraîche épaisse',
      '50 cl de lait',
      '2 gousses d’ail',
      '50 g de beurre',
      'Sel',
      'Poivre',
      'Muscade râpée'
    ],
    instructions: [
      'Préchauffer le four',
      'Préparer les pommes de terre',
      'Préparer la crème parfumée',
      'Disposer dans un plat',
      'Cuire au four'
    ],
    instructionDetails: [
      'Préchauffer le four à 180°C.',
      'Éplucher les pommes de terre et les couper en fines rondelles.',
      'Frotter le plat à gratin avec l’ail, puis beurrer.',
      'Mélanger la crème, le lait, le sel, le poivre et la muscade.',
      'Disposer les rondelles de pommes de terre dans le plat en couches, verser le mélange crème-lait.',
      'Enfourner pendant 1 heure jusqu’à ce que le dessus soit doré et fondant.'
    ],
    prepTime: '20 min',
    cookTime: '60 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Gratin-dauphinois.webp',
    category: 'Plat principal'
  },

  {
    id: 'chicken_curry_riz',
    name: 'Chicken curry et riz',
    nameArabic: 'دجاج بالكاري والأرز',
    ingredients: [
      '500 g de blanc de poulet',
      '2 oignons',
      '2 gousses d’ail',
      '3 cuillères à soupe de curry en poudre',
      '40 cl de lait de coco',
      '2 cuillères à soupe d’huile',
      'Sel',
      'Poivre',
      '200 g de riz basmati'
    ],
    instructions: [
      'Cuire le riz',
      'Préparer le poulet',
      'Ajouter le curry et le lait de coco',
      'Laisser mijoter',
      'Servir avec le riz'
    ],
    instructionDetails: [
      'Cuire le riz basmati dans de l’eau salée selon les instructions du paquet.',
      'Dans une poêle, faire chauffer l’huile et revenir les oignons et l’ail hachés.',
      'Ajouter le poulet coupé en dés et faire dorer.',
      'Incorporer le curry, mélanger, puis verser le lait de coco.',
      'Laisser mijoter à feu doux 15 minutes.',
      'Servir le curry bien chaud accompagné du riz.'
    ],
    prepTime: '15 min',
    cookTime: '25 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Chicken-curry-et-riz.webp',
    category: 'Plat principal'
  },

  {
    id: 'riz_legumes_viande',
    name: 'Riz aux légumes et viande',
    nameArabic: 'أرز بالخضار واللحم',
    ingredients: [
      '300 g de viande de bœuf en dés',
      '2 carottes',
      '1 poivron',
      '100 g de petits pois',
      '200 g de riz',
      '1 oignon',
      '2 cuillères à soupe d’huile',
      'Sel',
      'Poivre',
      'Épices (paprika, cumin)'
    ],
    instructions: [
      'Cuire le riz',
      'Faire revenir la viande',
      'Ajouter les légumes',
      'Mélanger avec le riz',
      'Assaisonner'
    ],
    instructionDetails: [
      'Cuire le riz dans de l’eau salée puis égoutter.',
      'Faire chauffer l’huile dans une poêle et faire revenir l’oignon haché.',
      'Ajouter la viande et la faire dorer.',
      'Incorporer les carottes, le poivron et les petits pois, laisser cuire 10 minutes.',
      'Ajouter le riz, assaisonner avec sel, poivre et épices, puis bien mélanger.'
    ],
    prepTime: '20 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Riz-aux-legumes-et-viande.webp',
    category: 'Plat principal'
  },
  {
    id: 'dolma',
    name: 'Dolma',
    nameArabic: 'دولمة',
    ingredients: [
      '4 courgettes',
      '4 poivrons',
      '300 g de viande hachée',
      '1 oignon',
      '200 g de riz',
      '2 cuillères à soupe de persil haché',
      '1 cuillère à café de paprika',
      'Sel',
      'Poivre',
      'Huile d’olive'
    ],
    instructions: [
      'Préparer les légumes',
      'Préparer la farce',
      'Farcir les légumes',
      'Cuire dans une sauce tomate'
    ],
    instructionDetails: [
      'Laver et vider les courgettes et les poivrons.',
      'Mélanger la viande hachée avec le riz, l’oignon haché, le persil, le sel, le poivre et le paprika.',
      'Farcir les légumes avec ce mélange.',
      'Préparer une sauce tomate avec oignon, ail, huile et tomate, disposer les légumes farcis dedans.',
      'Cuire à feu doux pendant environ 40 minutes.'
    ],
    prepTime: '25 min',
    cookTime: '40 min',
    difficulty: 'Moyen',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/dolma-B-1.webp',
    category: 'Plat principal'
  },
  {
    id: 'pates_creme_olives',
    name: 'Pâte crème fraîche aux olives',
    nameArabic: 'معكرونة بالكريمة والزيتون',
    ingredients: [
      '300 g de pâtes',
      '20 cl de crème fraîche',
      '100 g d’olives noires dénoyautées',
      '1 oignon',
      '2 cuillères à soupe d’huile d’olive',
      'Sel',
      'Poivre'
    ],
    instructions: [
      'Cuire les pâtes',
      'Préparer la sauce à la crème',
      'Ajouter les olives',
      'Mélanger avec les pâtes'
    ],
    instructionDetails: [
      'Cuire les pâtes dans de l’eau salée selon les instructions du paquet.',
      'Dans une poêle, chauffer l’huile d’olive et faire revenir l’oignon émincé.',
      'Ajouter la crème fraîche et assaisonner.',
      'Incorporer les olives coupées en rondelles.',
      'Mélanger la sauce avec les pâtes et servir chaud.'
    ],
    prepTime: '10 min',
    cookTime: '15 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/pate-ceme-fraiche.webp',
    category: 'Plat principal'
  },
  {
    id: 'gratin_epinards',
    name: 'Gratin épinards',
    nameArabic: 'غراتان السبانخ',
    ingredients: [
      '500 g d’épinards frais',
      '30 g de beurre',
      '30 g de farine',
      '50 cl de lait',
      '50 g de fromage râpé',
      'Sel',
      'Poivre',
      'Muscade'
    ],
    instructions: [
      'Préparer les épinards',
      'Préparer la béchamel',
      'Assembler le gratin',
      'Cuire au four'
    ],
    instructionDetails: [
      'Préchauffer le four à 180°C.',
      'Cuire les épinards à la vapeur puis les égoutter.',
      'Préparer une béchamel en faisant fondre le beurre, ajouter la farine puis le lait petit à petit.',
      'Assaisonner avec sel, poivre et muscade.',
      'Mélanger les épinards avec la béchamel, verser dans un plat à gratin et parsemer de fromage râpé.',
      'Enfourner 20 minutes.'
    ],
    prepTime: '15 min',
    cookTime: '20 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Gratin-epinards.webp',
    category: 'Plat principal'
  },
  {
    id: 'pates_gratinees_thon',
    name: 'Pâtes gratinées au four sauce béchamel et thon',
    nameArabic: 'معكرونة بالباشاميل والتونة في الفرن',
    ingredients: [
      '300 g de pâtes',
      '1 boîte de thon au naturel',
      '30 g de beurre',
      '30 g de farine',
      '50 cl de lait',
      '100 g de fromage râpé',
      'Sel',
      'Poivre'
    ],
    instructions: [
      'Cuire les pâtes',
      'Préparer la béchamel',
      'Mélanger avec le thon',
      'Mettre dans un plat',
      'Gratiner au four'
    ],
    instructionDetails: [
      'Cuire les pâtes dans de l’eau salée et égoutter.',
      'Préparer la béchamel : faire fondre le beurre, ajouter la farine puis le lait petit à petit.',
      'Assaisonner avec sel et poivre.',
      'Mélanger les pâtes, la béchamel et le thon émietté.',
      'Verser dans un plat à gratin, parsemer de fromage râpé.',
      'Enfourner 15 minutes à 200°C pour gratiner.'
    ],
    prepTime: '15 min',
    cookTime: '25 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Pates-gratinees.webp',
    category: 'Plat principal'
  },

   {
    id: 'salade-algeroise',
    name: 'Salade algéroise',
    nameArabic: 'سلطة جزائرية',
    ingredients: [
      'tomates',
      'poivrons',
      'oignons',
      'olives',
      'huile d\'olive',
      'vinaigre',
      'sel',
      'poivre'
    ],
    instructions: [
      'Laver et couper les légumes en petits dés',
      'Mélanger tous les légumes dans un saladier',
      'Assaisonner avec huile, vinaigre, sel et poivre',
      'Décorer avec des olives'
    ],
    instructionDetails: [
      'Laver soigneusement les tomates, poivrons et oignons, puis les couper en petits dés réguliers.',
      'Mettre tous les légumes coupés dans un grand saladier.',
      'Verser un filet d\'huile d\'olive et un peu de vinaigre selon votre goût.',
      'Saler, poivrer et mélanger délicatement.',
      'Ajouter quelques olives en décoration avant de servir.'
    ],
    prepTime: '15 min',
    cookTime: '0 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Salade-algeroise.webp',
    category: 'Entrée'
  },
  {
    id: 'salade-riz',
    name: 'Salade au riz',
    nameArabic: 'سلطة الأرز',
    ingredients: [
      'riz cuit',
      'thon',
      'maïs',
      'tomates',
      'poivrons',
      'œufs durs',
      'huile d\'olive',
      'sel',
      'poivre'
    ],
    instructions: [
      'Cuire le riz et le laisser refroidir',
      'Mélanger avec le thon, le maïs et les légumes coupés',
      'Assaisonner et décorer avec des œufs durs'
    ],
    instructionDetails: [
      'Cuire le riz dans de l\'eau salée, puis l\'égoutter et le laisser refroidir complètement.',
      'Égoutter le thon et le maïs, puis les ajouter au riz refroidi.',
      'Couper les tomates et les poivrons en petits morceaux et les incorporer.',
      'Assaisonner avec huile, sel et poivre.',
      'Couper les œufs durs en quartiers et les disposer sur le dessus.'
    ],
    prepTime: '20 min',
    cookTime: '10 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Salade-au-riz.webp',
    category: 'Entrée'
  },
  
  {
    id: 'kbab',
    name: 'Kbab',
    nameArabic: 'كباب',
    ingredients: [
      'viande hachée',
      'oignon',
      'ail',
      'coriandre fraîche',
      'cumin',
      'paprika',
      'sel',
      'poivre',
      'huile pour cuisson'
    ],
    instructions: [
      'Mélanger la viande avec les épices et aromates',
      'Former des brochettes',
      'Cuire sur grill ou poêle'
    ],
    instructionDetails: [
      'Mettre la viande hachée dans un saladier.',
      'Ajouter l\'oignon et l\'ail finement hachés, la coriandre ciselée, le cumin, le paprika, le sel et le poivre.',
      'Bien mélanger pour que les épices imprègnent la viande.',
      'Former des brochettes autour de pics en bois ou métal.',
      'Cuire sur un grill chaud ou une poêle légèrement huilée jusqu\'à cuisson complète.'
    ],
    prepTime: '15 min',
    cookTime: '15 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/kebab.webp',
    category: 'Plat Principal'
  },

  {
    id: 'soupe-legumes',
    name: 'Soupe de légumes',
    nameArabic: 'حساء الخضار',
    ingredients: [
      'pommes de terre',
      'carottes',
      'courgettes',
      'poireaux',
      'céleri',
      'huile d\'olive',
      'eau ou bouillon',
      'sel',
      'poivre'
    ],
    instructions: [
      'Laver et couper tous les légumes',
      'Faire revenir dans l’huile',
      'Ajouter l’eau ou le bouillon',
      'Cuire jusqu’à tendreté des légumes',
      'Mixer ou laisser en morceaux selon préférence'
    ],
    instructionDetails: [
      'Laver et éplucher les pommes de terre, carottes et courgettes, puis les couper en dés.',
      'Hacher les poireaux et le céleri.',
      'Faire chauffer l’huile d’olive dans une marmite et y faire revenir les légumes pendant 5 minutes.',
      'Verser l’eau ou le bouillon, saler et poivrer.',
      'Couvrir et laisser cuire environ 25 minutes, jusqu’à ce que les légumes soient tendres.',
      'Mixer pour obtenir une soupe lisse ou servir telle quelle.'
    ],
    prepTime: '15 min',
    cookTime: '25 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/soupe-de-legumes.webp',
    category: 'Entrée'
  },
 
  {
    id: 'chorba-tomate',
    name: 'Chorba à la tomate',
    nameArabic: 'شوربة الطماطم',
    ingredients: [
      'tomates mûres',
      'oignon',
      'ail',
      'huile d’olive',
      'bouillon',
      'sel',
      'poivre',
      'herbes aromatiques'
    ],
    instructions: [
      'Faire revenir oignon et ail dans l’huile',
      'Ajouter les tomates et cuire',
      'Mixer avec le bouillon',
      'Assaisonner et servir'
    ],
    instructionDetails: [
      'Émincer l’oignon et hacher l’ail, puis les faire revenir dans l’huile d’olive.',
      'Ajouter les tomates pelées et coupées en morceaux, laisser cuire 10 minutes.',
      'Verser le bouillon et cuire encore 10 minutes.',
      'Mixer le tout pour obtenir une texture lisse.',
      'Saler, poivrer et ajouter les herbes de votre choix.'
    ],
    prepTime: '10 min',
    cookTime: '20 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Chorba-a-la-tomate.webp',
    category: 'Entrée'
  },

  
    
  {
    id: 'tajine-poulet-olives',
    name: 'Tajine de poulet aux olives',
    nameArabic: 'طاجين الدجاج بالزيتون',
    ingredients: [
      'morceaux de poulet',
      'olives vertes',
      'oignons',
      'ail',
      'citron confit',
      'huile d’olive',
      'épices (curcuma, gingembre, poivre, sel)'
    ],
    instructions: [
      'Faire revenir le poulet avec oignons et épices',
      'Ajouter les olives et le citron confit',
      'Laisser mijoter jusqu’à cuisson complète'
    ],
    instructionDetails: [
      'Dans une cocotte, faire chauffer l’huile d’olive et y faire revenir les morceaux de poulet avec les oignons émincés.',
      'Ajouter les épices et bien mélanger.',
      'Verser un peu d’eau et laisser cuire à couvert 25 minutes.',
      'Incorporer les olives préalablement dessalées et les quartiers de citron confit.',
      'Poursuivre la cuisson encore 10 minutes et servir chaud.'
    ],
    prepTime: '15 min',
    cookTime: '40 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Tajine-de-poulet-aux-olives.webp',
    category: 'Plat Principal'
  },
  {
    id: 'dolma-legumes',
    name: 'Dolma de légumes farcis',
    nameArabic: 'دولما بالخضار المحشية',
    ingredients: [
      'courgettes',
      'poivrons',
      'tomates',
      'viande hachée',
      'riz',
      'oignons',
      'herbes aromatiques',
      'huile',
      'épices (poivre, sel, cannelle)'
    ],
    instructions: [
      'Préparer la farce avec viande, riz et assaisonnements',
      'Farcir les légumes',
      'Cuire dans une sauce tomate'
    ],
    instructionDetails: [
      'Mélanger la viande hachée avec le riz lavé, les oignons hachés, les herbes et les épices.',
      'Vider les légumes et les remplir avec la farce.',
      'Préparer une sauce tomate dans une marmite avec un peu d’huile.',
      'Disposer les légumes farcis dans la marmite, couvrir d’eau et laisser cuire à feu doux jusqu’à ce que tout soit tendre.'
    ],
    prepTime: '30 min',
    cookTime: '50 min',
    difficulty: 'Moyenne',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Dolma-de-legumes-farcis.webp',
    category: 'Plat Principal'
  },
  {
    id: 'tajine-kefta-oeufs',
    name: 'Tajine de kefta aux œufs',
    nameArabic: 'طاجين كفتة بالبيض',
    ingredients: [
      'viande hachée',
      'œufs',
      'oignons',
      'tomates',
      'ail',
      'huile d’olive',
      'épices (paprika, cumin, poivre, sel)'
    ],
    instructions: [
      'Préparer la sauce tomate',
      'Former des boulettes et les cuire dans la sauce',
      'Casser les œufs sur le dessus et cuire doucement'
    ],
    instructionDetails: [
      'Dans un tajine ou une poêle profonde, faire revenir l’oignon et l’ail dans l’huile.',
      'Ajouter les tomates râpées et les épices, laisser mijoter 10 minutes.',
      'Former des boulettes avec la viande hachée assaisonnée et les placer dans la sauce.',
      'Cuire à feu doux jusqu’à cuisson des boulettes.',
      'Casser les œufs sur la surface et couvrir jusqu’à ce que le blanc soit pris.'
    ],
    prepTime: '15 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/08/Tajine-de-kefta-aux-oeufs.webp',
    category: 'Plat Principal'
  },

  {
    id: 'soupe-detox-legumes',
    name: 'Soupe Détox aux Légumes',
    nameArabic: 'شوربة ديتوكس بالخضار',
    ingredients: [
      'carottes',
      'courgettes',
      'céleri',
      'brocoli',
      'ail',
      'oignons',
      'huile d’olive',
      'herbes fraîches (persil, coriandre)',
      'sel, poivre'
    ],
    instructions: [
      'Laver et couper les légumes',
      'Faire revenir oignon et ail',
      'Ajouter les légumes et couvrir d’eau',
      'Cuire jusqu’à tendreté'
    ],
    instructionDetails: [
      'Éplucher et couper tous les légumes en petits morceaux.',
      'Dans une marmite, faire revenir l’oignon et l’ail dans un peu d’huile d’olive.',
      'Ajouter les légumes, assaisonner de sel et poivre puis couvrir d’eau.',
      'Laisser cuire 25 à 30 minutes puis mixer pour une texture veloutée (optionnel).'
    ],
    prepTime: '15 min',
    cookTime: '30 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Soupe-Detox-aux-Legumes-1.webp',
    category: 'Soupe'
  },

  {
    id: 'salade-quinoa-legumes',
    name: 'Salade de Quinoa aux Légumes Croquants',
    nameArabic: 'سلطة الكينوا بالخضار المقرمشة',
    ingredients: [
      'quinoa',
      'concombre',
      'tomates cerises',
      'poivrons',
      'carottes râpées',
      'huile d’olive',
      'jus de citron',
      'sel, poivre'
    ],
    instructions: [
      'Cuire le quinoa',
      'Couper les légumes en dés',
      'Mélanger le tout avec assaisonnement'
    ],
    instructionDetails: [
      'Rincer le quinoa et le cuire dans deux fois son volume d’eau pendant 12-15 minutes.',
      'Égoutter et laisser refroidir.',
      'Couper les légumes croquants (concombre, tomates cerises, poivrons) en morceaux.',
      'Dans un grand saladier, mélanger quinoa, légumes et carottes râpées.',
      'Assaisonner avec huile d’olive, jus de citron, sel et poivre.'
    ],
    prepTime: '20 min',
    cookTime: '15 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Salade-de-Quinoa-aux-Legumes-1.webp',
    category: 'Salade'
  },
  {
    id: 'poulet-grille-legumes-vapeur',
    name: 'Poulet Grillé aux Herbes et Légumes Vapeur',
    nameArabic: 'دجاج مشوي بالأعشاب وخضار بالبخار',
    ingredients: [
      'blancs de poulet',
      'herbes fraîches (romarin, thym, persil)',
      'ail',
      'huile d’olive',
      'courgettes',
      'carottes',
      'brocoli',
      'sel, poivre'
    ],
    instructions: [
      'Mariner le poulet avec herbes et huile',
      'Griller le poulet',
      'Cuire les légumes à la vapeur',
      'Servir ensemble'
    ],
    instructionDetails: [
      'Préparer une marinade avec huile d’olive, ail haché, sel, poivre et herbes.',
      'Enduire les blancs de poulet et laisser mariner 30 minutes.',
      'Griller le poulet dans une poêle grill ou au four jusqu’à cuisson complète.',
      'Cuire les légumes à la vapeur 10-12 minutes pour qu’ils restent croquants.',
      'Servir le poulet avec les légumes vapeur.'
    ],
    prepTime: '20 min',
    cookTime: '25 min',
    difficulty: 'Facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Poulet-Grille-aux-Herbes-et-Legumes-Vapeur-1.webp',
    category: 'Plat Principal'
  },
  {
    id: 'smoothie-vert-minceur',
    name: 'Smoothie vert minceur',
    nameArabic: 'سموثي أخضر للتنحيف',
    ingredients: [
      'épinards frais',
      'concombre',
      'pomme verte',
      'citron',
      'gingembre frais',
      'eau ou lait végétal'
    ],
    instructions: [
      'Laver et couper les ingrédients',
      'Mettre dans un blender',
      'Mixer jusqu’à texture lisse'
    ],
    instructionDetails: [
      'Laver les épinards, couper le concombre et la pomme en morceaux.',
      'Presser le jus du citron et râper un petit morceau de gingembre.',
      'Mettre tous les ingrédients dans un blender avec de l’eau ou du lait végétal.',
      'Mixer jusqu’à obtenir une boisson homogène et onctueuse.',
      'Servir immédiatement bien frais.'
    ],
    prepTime: '10 min',
    cookTime: '0 min',
    difficulty: 'Très facile',
    imageUrl: 'https://kaswila.com/wp-content/uploads/2025/09/Smoothie-vert-minceur-1.webp',
    category: 'Boisson'
  },
  {
    id: 'salade-med-pois-chiches',
    name: 'Salade méditerranéenne aux pois chiches',
    nameArabic: 'سلطة متوسطية بالحمص',
    ingredients: [
      'pois chiches cuits',
      'concombre',
      'tomates cerises',
      'poivron rouge',
      'oignon rouge',
      'persil frais',
      'huile d’olive',
      'jus de citron',
      'sel, poivre',
      'olives noires'
    ],
    instructions: [
      'Couper les légumes',
      'Ajouter les pois chiches',
      'Assaisonner avec citron et huile d’olive',
      'Mélanger et servir'
    ],
    instructionDetails: [
      'Égoutter et rincer les pois chiches.',
      'Couper le concombre, les tomates cerises, le poivron rouge et l’oignon rouge en petits morceaux.',
      'Mettre dans un saladier puis ajouter les pois chiches et le persil haché.',
      'Assaisonner avec huile d’olive, jus de citron, sel et poivre.',
      'Ajouter quelques olives noires et mélanger.'
    ],
    prepTime: '15 min',
    cookTime: '0 min',
    difficulty: 'Facile',
    imageUrl: 'https://example.com/salade-med-pois-chiches.jpg',
    category: 'Salade'
  },
  {
    id: 'smoothie-proteine-banane-avoine',
    name: 'Smoothie protéiné banane – avoine',
    nameArabic: 'سموثي بروتيني بالموز والشوفان',
    ingredients: [
      'banane',
      'flocons d’avoine',
      'yaourt nature ou lait végétal',
      'miel',
      'vanille',
      'glaçons (optionnel)'
    ],
    instructions: [
      'Mettre tous les ingrédients dans un blender',
      'Mixer jusqu’à texture lisse',
      'Servir frais'
    ],
    instructionDetails: [
      'Couper la banane en rondelles.',
      'Mettre la banane, les flocons d’avoine, le yaourt (ou lait végétal), un peu de miel et une pincée de vanille dans un blender.',
      'Mixer jusqu’à obtenir une texture crémeuse.',
      'Ajouter quelques glaçons si désiré et mixer encore.',
      'Servir immédiatement.'
    ],
    prepTime: '5 min',
    cookTime: '0 min',
    difficulty: 'Très facile',
    imageUrl: 'https://example.com/smoothie-proteine-banane-avoine.jpg',
    category: 'Boisson'
  },
  {
    id: 'omelette-blanche-epinards',
    name: 'Omelette blanche aux épinards',
    nameArabic: 'عجة بياض البيض بالسبانخ',
    ingredients: [
      'blancs d’œufs',
      'épinards frais',
      'sel, poivre',
      'huile d’olive',
      'fromage frais léger (optionnel)'
    ],
    instructions: [
      'Battre les blancs d’œufs',
      'Faire revenir les épinards',
      'Cuire l’omelette',
      'Plier et servir'
    ],
    instructionDetails: [
      'Battre les blancs d’œufs avec sel et poivre.',
      'Faire revenir légèrement les épinards dans une poêle avec un peu d’huile.',
      'Verser les blancs d’œufs sur les épinards et cuire à feu doux.',
      'Plier l’omelette et ajouter un peu de fromage frais si souhaité.',
      'Servir chaud.'
    ],
    prepTime: '5 min',
    cookTime: '8 min',
    difficulty: 'Facile',
    imageUrl: 'https://example.com/omelette-blanche-epinards.jpg',
    category: 'Plat léger'
  },
  {
    id: 'riz-complet-legumes-vapeur',
    name: 'Riz complet aux légumes vapeur',
    nameArabic: 'أرز كامل بالخضار المطهوة بالبخار',
    ingredients: [
      'riz complet',
      'carottes',
      'courgettes',
      'brocoli',
      'sel',
      'huile d’olive',
      'épices douces (curcuma, paprika)'
    ],
    instructions: [
      'Cuire le riz complet',
      'Cuire les légumes à la vapeur',
      'Assaisonner et mélanger'
    ],
    instructionDetails: [
      'Rincer le riz complet puis le cuire dans 2,5 fois son volume d’eau pendant 35-40 minutes.',
      'Couper les légumes en morceaux et les cuire à la vapeur 10-12 minutes.',
      'Assaisonner avec un filet d’huile d’olive, sel et épices douces.',
      'Mélanger le riz et les légumes ou servir séparément.'
    ],
    prepTime: '10 min',
    cookTime: '40 min',
    difficulty: 'Facile',
    imageUrl: 'https://example.com/riz-complet-legumes.jpg',
    category: 'Plat principal'
    },
  
];

